/*    
 *  _________________________________________
 * / Stop right there, ya dingus. This file  \
 * \ should not be edited.                   /
 *  -----------------------------------------
 *  \
 *   \
 *      __
 *     /  \
 *     |  |
 *     @  @
 *     |  |
 *     || |/
 *     || ||
 *     |\_/|
 *     \___/
 *    
 * This file is automatically generated through https://localise.biz.
 *                                                                         
 * To update this file:
 *
 *  $ npm run update-language
 *
 * Last update:    Mon Jul 27 2026 14:28:27 GMT+0200 (Central European Summer Time)
 * Language keys:  13
 * Language code:  fr
 *
 */

const language = {
  "resources": {
    "alarms": {
      "name": "Alarme |||| Alarmes",
      "create_title": "Créer une alarme",
      "text": {
        "alarm_creator": "Créateur d'alarme",
        "alarm_creator_explanation": "Sélectionnez la personne ou l'objet qui crée l'alarme. La position, les groupes et la configuration de réponse de cet objet ou de cette personne seront utilisés pendant le processus de gestion de l'alarme.",
        "alarm_information": "Informations d'alarme",
        "alarm_information_explanation": "Les informations ci-dessous permettent de déterminer ce qui doit se passer pendant l'alarme. Choisissez un nom d'alarme court (par exemple, « Alarme de panique ») et sélectionnez l'urgence de l'alarme.",
        "severity_options": {
          "red": "Rouge (urgent)",
          "orange": "Orange (nécessite une attention particulière)",
          "green": "Vert (non urgent)"
        },
        "type_options": {
          "panic": "Panique",
          "assistance": "Assistance",
          "test": "Test",
          "outage": "Panne",
          "fire": "Feu",
          "medical": "Médical",
          "mandown": "Homme à terre",
          "other": "Autre"
        },
        "procedure_placeholder": "La procédure est présentée dans le gestionnaire d'alarmes X-Guard et dans l'application X-Guard Alarm.\n\nDécrivez ce que doivent faire les personnes qui viennent en aide.",
        "ack_definition": "Exiger une reconnaissance",
        "ack_explanation": "Par défaut, les alarmes nécessitent un accusé de réception. Les alarmes non acquittées peuvent être traitées via le gestionnaire d'alarmes X-Guard et l'application X-Guard Alarm.",
        "ack": {
          "no_time": "Pas de temps défini",
          "open_alarm": "Ouvrir l'alarme",
          "not_needed": "Pas nécessaire",
          "acked": "Alarme reconnue",
          "value": "Nécessite une reconnaissance (recommandé)"
        },
        "page_info": "Cette page présente un aperçu rapide des alarmes de votre organisation. Ouvrez le gestionnaire d'alarmes X-Guard pour plus de détails sur une alarme.",
        "acknowledge_all": "Reconnaître tout",
        "acknowledge_confirmation": "Êtes-vous sûr de vouloir reconnaître les alarmes %{length} ?",
        "acknowledge_selected": "Reconnaître la sélection",
        "acknowledge": "Reconnaître",
        "bhvk": {
          "create_title": "Faire l'alarme",
          "create_subtitle": "Créez une alarme de démonstration en appuyant sur le bouton pulsé à gauche. Lorsque vous appuyez dessus, vous serez averti soit dans l'application, soit par un appel téléphonique."
        },
        "how_to_receive_title": "Comment souhaitez-vous recevoir les alarmes ?",
        "how_to_receive_subtitle": "Si l'application est téléchargée, le système l'utilisera d'abord pour vous avertir des nouvelles alarmes. Si vous souhaitez uniquement être appelé, supprimez l'application.",
        "receive_options": {
          "call": "Recevoir un appel",
          "app": "Via l'application"
        },
        "app_explanation": {
          "1": "1. Installez l'application",
          "2_title": "2. Connexion à l'application",
          "2_2": "Votre nom d'utilisateur pour vous connecter est :",
          "2_3": "L'application vous donnera des instructions supplémentaires.",
          "1_title": "3. Prêt à déclencher des alarmes",
          "3_2": "Appuyez sur le bouton pour déclencher une alarme",
          "under_buttons": "L'application peut être téléchargée dans l'App Store ou sur Google Play"
        },
        "bhvk_alarm_created": "Alarme créée. Vous recevrez cette alarme via la méthode sélectionnée.",
        "simulation_result": "Les actions suivantes seront effectuées :",
        "no_alarms": "Aucune alarme n'a été déclenchée au cours des 7 derniers jours.",
        "notified": "Notifié",
        "will_help": "Cela aidera",
        "will_not_help": "Cela n'aidera pas",
        "nobody_notified": "Personne, lisez pourquoi ici",
        "view_alarms": "Afficher les alarmes",
        "create_an_alarm": "Créer une alarme",
        "title_subtext": "Sur cette page, vous trouverez un aperçu de toutes les alarmes.",
        "no_links": "Aucun lien spécifié pour la réponse",
        "no_one_called_for_link": "Pour le moment, personne n'est sollicité pour ce processus."
      },
      "fields": {
        "name": "Nom de l'alarme",
        "severity": "Gravité",
        "type": "Type d'alarme",
        "procedure": "Procédure",
        "ack": {
          "name": "Nécessite une reconnaissance",
          "value": "Reconnu"
        },
        "alarmCenter": {
          "name": "Centre d'alarme"
        },
        "customer": {
          "_id": "Client"
        },
        "mergeHistory": "Dédupliqué"
      }
    },
    "assets": {
      "name": "Actif |||| Actifs",
      "text": {
        "annotation": "Cette page n'affiche aucun utilisateur d'application",
        "without_app_title": "Actifs sans application",
        "single_name": "Actif",
        "general": "Général",
        "properties": "Propriétés",
        "response": "Réponse",
        "app": "Application",
        "app_mode_not_editable": "Le mode application ne peut pas être modifié",
        "app_available_explanation": "Lorsque cette option est activée, l'utilisateur de l'application peut recevoir des demandes d'aide concernant les alarmes des utilisateurs à proximité.",
        "download_history_button": "Télécharger l'historique",
        "delete_user": "Supprimer l'utilisateur",
        "groups_updated": "Groupes mis à jour",
        "edit_groups": "Modifier les groupes",
        "without_app_description": "Les actifs sont des personnes ou des objets qui ne sont pas liés à l'application X-Guard Alarm. Vous pouvez afficher et modifier des actifs ici. L'ajout et la suppression d'actifs ne sont pas possibles, car ils sont parfois utilisés pour des configurations avancées dans votre organisation. Dans la plupart des cas, vous souhaitez créer un [Utilisateur](%{adminPath}) ou un [Utilisateur d'application](%{appUserPath}) au lieu d'un actif.",
        "has_app": "Est-ce un compte d'application ?",
        "add_bhv": "Ajoutez BHV'er",
        "add_user": "Ajouter un utilisateur",
        "add_user_tooltip": "Après avoir commandé, vous pouvez ajouter des utilisateurs",
        "add_bhv_tooltip": "Après avoir passé commande, vous pouvez ajouter des BHV'ers",
        "bhvk_deleted": "Utilisateur supprimé",
        "number_of_available_users": "Nombre total d'utilisateurs disponibles pour recevoir des alarmes",
        "number_of_expiring_certifications": "Nombre total de certificats arrivant à expiration",
        "number_of_expired_certifications": "Nombre total de certificats expirés"
      },
      "fields": {
        "user": {
          "_id": "Utilisateur"
        },
        "externalId": "ID externe",
        "description": "Description",
        "phoneNumber": "Numéro de téléphone",
        "smsNumber": "Numéro SMS",
        "email": "E-mail",
        "image": "Image",
        "available": "Disponible",
        "staticResponders": {
          "name": "Répondeurs statiques",
          "staticResponder": "Répondeur statique",
          "priority": "Priorité"
        },
        "position": {
          "provider": "La position est statique"
        },
        "invisibleResponder": "Est-ce un répondeur invisible ?",
        "allowContactOnOwnAlarms": "Autoriser le contact sur ses propres alarmes (Afficher le numéro de téléphone dans le gestionnaire d'alarmes)",
        "lastObservationAt": "Dernière observation à",
        "insideZones": "Zones intérieures",
        "can_receive": "Sur appel pour les autres",
        "my_security": "Ma sécurité",
        "last_active_at": "Dernière activité à",
        "has_app": "Utilise l'application"
      },
      "download_history_for_last": "Télécharger l'historique pour la dernière fois :",
      "certifications": {
        "fields": {
          "documentary_proof": "Preuve documentaire",
          "first_issued_on": "Première publication le",
          "last_received_on": "Renouvelé le",
          "expiry_date": "Date d'expiration",
          "planned_renewal_date": "Renouvellement prévu"
        },
        "text": {
          "add_certification": "Ajouter un certificat",
          "sub_title": "Certificats",
          "not_provided": "Non fourni",
          "not_required": "Non requis",
          "not_required_description": "Aucune preuve documentaire n'est requise pour cette catégorie de certification.",
          "title_single": "Certificat",
          "certification_deleted": "Certificat supprimé",
          "expiry_date_input_helper_text": "La date d'expiration est préremplie à partir de la dernière date de réception, plus la période de validité de la catégorie de certification. Vous pouvez la modifier manuellement si nécessaire.",
          "view_document": "Consulter le document",
          "drop_document_to_upload": "Déposez le document pour le télécharger ou cliquez dessus pour le sélectionner.",
          "edit_certification_title": "Modifier le certificat %{category} pour %{user_name}",
          "renew": "Renouveler",
          "renew_now_modal_title": "Renouveler maintenant",
          "renew_now_modal_helper_text": "La date d'expiration est préremplie à partir de la dernière date de réception, plus la période de validité de la catégorie de certification. Vous pouvez la modifier manuellement si nécessaire.",
          "plan_renewal_modal_title": "Planifier le renouvellement",
          "renew_bulk": "Renouveler les certificats",
          "assign_document_to_user": "Attribuer à un utilisateur",
          "bulk_assign_documents_helper": "Attribuez chaque document téléchargé à l'utilisateur concerné.",
          "reset_document_assignments": "Réinitialiser les attributions",
          "bulk_documents_count_mismatch": "Le nombre de documents téléchargés doit correspondre au nombre d'utilisateurs sélectionnés.",
          "bulk_documents_assignment_incomplete": "Attribuez chaque document à un utilisateur unique. Chaque utilisateur sélectionné doit recevoir exactement un document.",
          "drop_documents_to_upload": "Déposez les documents pour les télécharger ou cliquez pour les sélectionner",
          "bulk_upload_documents_helper": "Téléversez les justificatifs pour l'utilisateur sélectionné. |||| Téléversez %{smart_count} justificatifs pour les utilisateurs sélectionnés.",
          "select_categories": "Sélectionner une catégorie de certification",
          "preview_file": "Aperçu du fichier",
          "select_user": "Sélectionner un utilisateur",
          "select_category": "Sélectionner une catégorie",
          "planned_renewal_date_helper_text": "Les notifications par e-mail sont reportées jusqu'à la date de renouvellement prévue.",
          "missing_documentary_proof": "preuve documentaire manquante",
          "category_tooltip": "%{name} - %{expiry}",
          "category_tooltip_with_missing_proof": "%{name} - %{missing_proof}, %{expiry}",
          "planned_renewal_in_tooltip": "renouvellement prévu %{date}",
          "renew_now": "Certificat déjà renouvelé",
          "plan_renewal_subtitle": "Planifiez quand les certificats sélectionnés doivent être renouvelés",
          "renew_now_subtitle": "Définissez de nouvelles dates de renouvellement et d'expiration pour les certificats sélectionnés",
          "choice_dialog_subtitle": "Comment souhaitez-vous mettre à jour les certificats sélectionnés ?",
          "choice_dialog_title": "Gérer le renouvellement",
          "plan_renewal": "Le certificat sera renouvelé à l'avenir",
          "apply_dates_to_all": "S'appliquer à tous",
          "no_preview": "Aucun aperçu",
          "no_common_category_tooltip": "Cet utilisateur n’a aucun certificat en commun avec les utilisateurs sélectionnés",
          "no_common_certificates": "Les utilisateurs sélectionnés n’ont aucun certificat en commun",
          "selected_user_no_certificates": "L’utilisateur sélectionné n’a aucun certificat"
        },
        "validation": {
          "expiry_date_must_be_future": "La date d'expiration doit être future."
        }
      }
    },
    "app-users": {
      "text": {
        "sent_configuration": "Configuration envoyée à l'appareil",
        "sent_configuration_failed": "Échec de l'envoi de la configuration à l'appareil",
        "sent_log": "Demande de journal envoyée à l'appareil",
        "sent_log_failed": "Échec de l'envoi de la demande de journal à l'appareil",
        "actions": "Actes",
        "send_critical_title": "Envoyer comme critique",
        "send_critical_explanation": "Ce commutateur indique si la notification doit être envoyée comme critique. Réglez le commutateur sur la position souhaitée\navant de cliquer sur le bouton pour envoyer la notification.",
        "configuration_update_title": "Mise à jour de la configuration",
        "configuration_notification_title": "Envoyer une notification de configuration",
        "configuration_notification_explanation": "Cela enverra une notification à l'appareil avec la demande de cliquer sur la notification.\nSi tel est le cas, leur configuration est immédiatement rechargée",
        "log_notification_title": "Demander le journal de l'appareil",
        "log_notification_explanation": "Cela enverra une notification à l'appareil avec la demande de cliquer sur la notification.\nSi tel est le cas, l'appareil télécharge un journal vers l'équipe de développement.",
        "device_info": "Informations sur l'appareil",
        "installed_version": "Version installée",
        "available_version": "Version disponible",
        "compliance_state": "État de conformité",
        "compliance_true": "En conformité",
        "compliance_false": "Non conforme",
        "device_profile": "Profil de l'appareil",
        "permissions": "Autorisations (uniquement pour le système d'exploitation actuel)",
        "saving_group_successful": "Les groupes de sauvetage réussissent",
        "saving_group_failed": "La sauvegarde des groupes a échoué",
        "config": "Configuration",
        "group_title": "Groupes",
        "group_explanation": "Si deux groupes modifient les mêmes clés de configuration, le dernier groupe écrasera les groupes définis précédemment. Assurez-vous que l'ordre des groupes est correct.",
        "last_sync": "Dernière synchronisation",
        "last_config_update": "Dernière mise à jour de la configuration",
        "last_config_compliance": "Conformité de la dernière configuration",
        "reset_groups": "Réinitialiser les groupes",
        "save_groups": "Enregistrer des groupes",
        "no_valid_config": "Cet utilisateur n'a pas de configuration d'appareil valide et ne peut pas être modifié",
        "download_group": "Groupe ? Laissez vide pour ne pas avoir de groupe attaché.",
        "view_device_json": "Afficher la console pour l'appareil JSON",
        "configuration": "Configuration",
        "show_unmodified_keys": "Afficher les clés non modifiées",
        "delete_success": "Utilisateurs d'applications supprimés",
        "delete_success_single": "Utilisateur de l'application supprimé",
        "delete_failed": "La suppression des utilisateurs de l'application a échoué",
        "delete_failed_single": "La suppression de l'utilisateur de l'application a échoué",
        "delete_title": "Supprimer les utilisateurs de l'application",
        "delete_all_devices": "Supprimer tous les appareils",
        "updated": "Mise à jour des utilisateurs de l'application",
        "title": "Utilisateurs de l'application",
        "created": "Utilisateur de l'application créé ! L'utilisateur peut désormais se connecter avec %{username} via l'application X-Guard Alarm",
        "create_explanation": "Pour vous inscrire, ouvrez l'application X-Guard Alarm et scannez le code QR de l'organisation",
        "page_info": "Les utilisateurs de l'application ont la possibilité de se connecter à l'application X-Guard Alarm. Les utilisateurs de l'application ne peuvent pas se connecter à nos tableaux de bord.",
        "group_and_config_button_title": "Groupes et configuration",
        "config_and_groups_updated": "Groupes et configuration mis à jour !",
        "fill_phonenumber": "Entrez d'abord un numéro de téléphone",
        "available_helper": "Si l'option « Recevoir des alarmes » est activée, ce compte recevra activement les alarmes éligibles. Cela se produit soit via un appel téléphonique, soit, si vous êtes connecté, via l'application.",
        "warning_sends_email": "Attention : ce profil d'inscription envoie un e-mail au nouvel utilisateur",
        "create_continue": "Comment voulez-vous continuer ?",
        "create_modal_intro": "Les utilisateurs de l'application peuvent être enregistrés de deux manières. Vous pouvez laisser l'utilisateur le faire lui-même en scannant un code QR lors de l'ouverture de l'application, ou vous pouvez créer l'utilisateur vous-même.",
        "create_modal_open_qrcodes": "Ouvrir les codes QR",
        "create_modal_manually_create_user": "Créer un utilisateur manuellement",
        "devlog_notification_title": "Demander le journal de développement de l'appareil",
        "go_to_connected_users": "Accéder à l'utilisateur connecté",
        "ios_config_warning": "Ce groupe contient des touches qui ne fonctionnent pas sur iOS. Ces touches sont liées à la planification. Les autres touches de ce groupe restent fonctionnelles.",
        "include_button_count": "Nombre de boutons Flic",
        "device_logs_title": "Journaux de l'appareil",
        "device_logs_open_uploads": "Afficher les journaux des appareils téléchargés",
        "device_logs_open_uploads_explanation": "Sélectionnez un ou plusieurs journaux d'appareils téléchargés et chargez-les à partir de l'API de rapports.",
        "device_logs_uploads_modal_title": "Téléchargements des journaux de l'appareil",
        "device_logs_connected_device": "Appareil connecté",
        "device_logs_upload_fetch_failed": "Échec du chargement des journaux de l'appareil.",
        "device_logs_no_connected_device": "Aucun appareil connecté n'a été trouvé pour cet utilisateur.",
        "device_logs_uploads_empty": "Aucun journal de périphérique n'a été trouvé pour cet appareil connecté.",
        "device_logs_upload_created_at": "Créé à",
        "device_logs_upload_start_date": "Date de début",
        "device_logs_upload_end_date": "Date de fin",
        "device_logs_upload_count": "Compteur de logs",
        "device_logs_continue": "Continuer",
        "device_logs_result_modal_title": "Journaux de l'appareil",
        "device_logs_group_label": "Télécharger",
        "device_logs_fetch_failed": "Impossible de charger les journaux du périphérique sélectionné.",
        "device_logs_fetch_group_failed": "Impossible de charger les journaux pour ce chargement.",
        "device_logs_upload_severity_counts": "Nombre de cas de gravité",
        "device_logs_download": "Télécharger les journaux",
        "device_logs_severity_filter": "Gravité",
        "device_logs_severity_filter_all": "Tous",
        "device_logs_show_ctx": "Afficher le contexte"
      },
      "copy_device_json": "Copier le périphérique JSON",
      "text_create_register_via_qr": "L'utilisateur doit s'enregistrer via le code QR",
      "text_create_continue_to_create": "Je vais créer manuellement l'utilisateur de l'application"
    },
    "asset-groups": {
      "fields": {
        "description": "Description",
        "asset_count": "Nombre de personnes",
        "assets": "Actifs",
        "bhvk_count": "Nombre de membres",
        "bhvk_count_button": "Afficher %{length} boutons ou personnes"
      },
      "text": {
        "title": "Groupes d'actifs",
        "title_single": "Groupe",
        "page_info": "Les groupes sont utilisés par certaines configurations en coulisses qui peuvent affecter la réponse et la création des alarmes.\n\nVous pouvez utiliser cette page pour vérifier que vos groupes sont définis comme prévu.",
        "no_assets": "Aucune personne ni aucun objet",
        "create_title": "Créer un nouveau groupe",
        "create_explanation": "Les groupes peuvent être utilisés pour différencier les utilisateurs. X-Guard est capable de lier différentes configurations pour l'application et la réponse aux alarmes à un groupe.",
        "add_person": "Ajouter une personne",
        "delete_warning": "Ce groupe est utilisé en configuration pour la gestion des alarmes ou sur un kiosque.",
        "delete_warning_multiple": "Un ou plusieurs des groupes sélectionnés sont utilisés pour configurer la manière dont les alarmes sont gérées.",
        "delete_confirmation": "Je comprends qu'en poursuivant la procédure d'alarme, celle-ci pourrait être interrompue. Je ne supprimerai pas ce groupe à moins d'être sûr que la procédure d'alarme fonctionne toujours correctement."
      },
      "name": "Groupes"
    },
    "beacons": {
      "text": {
        "share_types": {
          "public": "Publique",
          "default": "Défaut"
        },
        "code": "Code",
        "title": "Balises",
        "low_battery": "La balise a une batterie faible",
        "beacon_last_seen": "Balise non vue ces derniers temps",
        "beacon_healthy": "Balise en bonne santé",
        "in_last_hour": "Au cours de la dernière heure"
      },
      "fields": {
        "codes": "Codes",
        "rssiAddend": "Addendum RSSI",
        "zone": {
          "_id": "Zone"
        },
        "state": {
          "lastSeenAt": "Vu pour la dernière fois à"
        },
        "share": {
          "type": "Type de partage"
        },
        "beacon_code": "Code de balise"
      }
    },
    "customer-links": {
      "fields": {
        "groups": "Groupes",
        "alarmLevels": "Niveaux d'alarme",
        "processTemplate": {
          "id": "Modèle de processus"
        },
        "level": {
          "green": "Vert",
          "orange": "Orange",
          "red": "Rouge",
          "mandown": "Homme à terre"
        },
        "groupType": "Type de groupe"
      },
      "text": {
        "title": "Liens clients",
        "group_types": {
          "all": "Tous les groupes",
          "none": "Aucun groupe",
          "some": "Certains groupes",
          "not_in": "Pas dans des groupes spécifiques"
        },
        "types_placeholder": "Lorsqu'aucun type n'est sélectionné, le lien client sera actif pour tous les types"
      }
    },
    "process-templates": {
      "text": {
        "no_asset_error": "Aucun actif sélectionné",
        "simulation_error": "Erreur dans la simulation",
        "previous_stage_delay": "Délai par rapport à l'étape précédente : %{delay} secondes",
        "query_speed": "Vitesse de requête",
        "alarmcenter_escalate": "Intensifier",
        "alarmcenter_queue_name": "Nom de la file d'attente",
        "no_results_in_stage": "Aucun résultat à ce stade",
        "kilometers": "kilomètres",
        "asset_distance": "Distance",
        "simulate_process": "Simuler le processus ATS",
        "simulate": "Simuler",
        "simulation_started": "Simulation démarrée",
        "simulation_started_secondary": "ATS est en cours de simulation, veuillez patienter",
        "title": "Modèles de processus",
        "if_script": "Si scénario",
        "taskTemplate": {
          "id": "Modèle de tâche"
        },
        "schedule_tasks": "Planifier des tâches",
        "scope_customer": "Spécifique au client",
        "scope_global": "Global",
        "include_global_templates": "Inclure les modèles globaux",
        "global_badge": "Global",
        "add_step": "Ajouter une étape",
        "remove_step": "Supprimer l'étape",
        "remove_step_confirm": "Voulez-vous vraiment supprimer cette étape ?",
        "duplicate_step": "Dupliquer l'étape",
        "step_number": "Étape %{number}",
        "always_execute": "Toujours exécuter",
        "meta_script": "Données d'entrée",
        "xgac_filter": "Filtre d'actifs",
        "request_filters": "Filtres de requêtes",
        "clone": "Cloner",
        "contacted_not_before": "Pas contacté auparavant",
        "asset_id_not_own": "ID d'asset non propre",
        "asset_id_own": "ID d'asset propre",
        "custom_filter_key": "Sélectionnez ou saisissez une clé de filtre",
        "filters": "Filtres",
        "add_filter": "Ajouter un filtre",
        "invalid_filter_key": "Cette clé de filtre n'est pas prise en charge par ATS getAssets",
        "invalid_filter_value": "Valeur de filtre invalide",
        "max_results": "Résultats max. (0 pour illimité)",
        "max_unlimited": "Illimité",
        "max_distance_warning": "Avertissement : ne sélectionnez pas plus de 10 éléments lors de l'utilisation du filtre de distance. Vérifiez le résultat de la simulation avant de continuer.",
        "filter_available_yes": "Disponible",
        "filter_available_no": "Non disponible",
        "comparator_equals": "égal à",
        "comparator_not_equals": "pas égal",
        "comparator_less_than": "inférieur à",
        "comparator_less_than_or_equal": "inférieur ou égal à",
        "comparator_greater_than": "supérieur à",
        "comparator_greater_than_or_equal": "supérieur ou égal à",
        "same_as_previous_step": "Identique à l'étape précédente",
        "step_not_configured": "Non configuré",
        "schedule_tasks_required": "Au moins une tâche planifiée est requise",
        "meta_data": "Métadonnées",
        "meta_data_variables": "Variables : %{variables}",
        "meta_data_example": "Exemple",
        "any_own_groups": "Tous les groupes propres",
        "filter_family_groups": "Groupe",
        "filter_family_embedded_timestamp": "Dernière observation",
        "filter_family_id": "ID d'asset",
        "filter_family_inside_zones": "Dans la zone",
        "filter_option_contacted": "Contacté",
        "filter_option_distance": "Distance (mètres)",
        "filter_option_asset_id": "ID d'asset",
        "filter_option_customer_id": "ID client",
        "comparator_younger": "plus récent que (secondes)",
        "comparator_contains": "contient",
        "comparator_not_contains": "ne contient pas",
        "comparator_older": "plus ancien que (secondes)"
      },
      "fields": {
        "processName": "Nom du processus",
        "description": "Description",
        "delay": "Retard",
        "filter_value": "Valeur",
        "filter_key": "Filtre",
        "required_confirmations": "Confirmations requises",
        "filter_comparator": "Comparateur",
        "filter_value_seconds": "Secondes"
      }
    },
    "users": {
      "fields": {
        "username": "Nom d'utilisateur",
        "group_restrictions": "Restrictions (par groupe)",
        "roles": "Rôles",
        "lastActiveAt": "Dernière activité à",
        "map_viewer": "A accès à la carte en direct",
        "userPolicies": {
          "disablePasswordlessLogin": "Désactiver la connexion sans mot de passe"
        },
        "accessRequest": {
          "validUntil": "A accès jusqu'au (laisser vide si l'accès doit être illimité)"
        },
        "certification_categories": "Certificats"
      },
      "text": {
        "password_reset_sent": "Demande de réinitialisation du mot de passe envoyée",
        "password_reset_failed": "La demande de réinitialisation du mot de passe a échoué",
        "password_reset_button": "Envoyer un e-mail de réinitialisation du mot de passe",
        "password_reset_button_description": "Etes-vous sûr de vouloir réinitialiser le mot de passe de cet utilisateur ? Il devra définir un nouveau mot de passe lors de sa première connexion.",
        "password_reset_mail_confirm": "Envoyer un e-mail",
        "roles": {
          "app_user": "Utilisateur de l'application - ne pas définir",
          "map_viewer": "Visionneuse de carte",
          "centralist": "Centraliste",
          "customer_admin": "Administrateur client",
          "viewer": "Téléspectateur",
          "alarm_responder": "Répondeur d'alarme",
          "ats_responder": "Répondeur ATS",
          "kioskUser": "Afficher l'utilisateur",
          "customer_admin_external_id": "Peut ajouter ou modifier un identifiant externe",
          "customer_admin_special_username": "Peut créer des utilisateurs avec un nom d'utilisateur non basé sur l'adresse e-mail",
          "flic_hub_tester": "Testeur de moyeu Flic",
          "customer_admin_app_user_history": "Peut télécharger l'historique des utilisateurs de l'application",
          "fingerprinter": "Empreinte digitale",
          "bhvk_trial": "Utilisateur d'essai du BHV-Knop",
          "bhvk_admin": "Administrateur utilisateur BHV-Knop",
          "apr_visible": "Peut démarrer Alarm Professional Response (Sequrix)",
          "sales_admin": "Administration des ventes",
          "support_admin": "Administrateur de support"
        },
        "roles_title": "Rôles",
        "invalid_phone": "Doit être un numéro de téléphone valide, commençant par +",
        "invalid_sms": "Doit être un numéro de SMS valide, commençant par +",
        "title": "Utilisateurs",
        "customer_user_relations": "Relation client-utilisateur",
        "update_success": "Mise à jour par l'utilisateur",
        "admins_title": "Administrateurs",
        "username_already_exists": "Le nom d'utilisateur existe déjà, choisissez-en un autre pour continuer",
        "page_info": "Cette page affiche les utilisateurs qui peuvent se connecter au gestionnaire d'alarmes X-Guard et/ou au tableau de bord de gestion X-Guard.",
        "access_to_dashboard": "Accès au tableau de bord",
        "receives_alarms": "Reçoit les alarmes",
        "saving_successful": "Utilisateur enregistré !",
        "sub_title": "Cette page affiche tous les utilisateurs de vos organisations BHV-Knop. Il existe des paramètres par utilisateur.",
        "available": "Reçoit les alarmes",
        "create_success": "Créé par l'utilisateur",
        "has_access_to_dashboard": "A accès au tableau de bord de gestion",
        "has_access_to_am": "A accès au gestionnaire d'alarmes",
        "add": "Ajouter un utilisateur",
        "manually": "Manuellement",
        "username_should_be_email": "Les noms d'utilisateur doivent être basés sur l'adresse e-mail des utilisateurs. Dans le cas contraire, la connexion de cet utilisateur sera plus difficile.",
        "delete_users": "Supprimer des utilisateurs",
        "delete_users_warning": "Etes-vous sûr de vouloir supprimer cet utilisateur ? |||| Etes-vous sûr de vouloir supprimer %{smart_count} utilisateurs ?",
        "users_with": {
          "multiple_connections": "Attention ! Un utilisateur est connecté à plusieurs clients. Affichez-les ci-dessous. |||| Attention ! Un utilisateur est connecté à plusieurs clients. Affichez-les ci-dessous."
        },
        "2fa_title": "Activer l'authentification à deux facteurs",
        "2fa_enable_description": "Avec l'authentification à deux facteurs activée, votre compte est plus sécurisé. Une fois activée, le code vous sera demandé dans l'application Authenticator de votre choix à chaque connexion au tableau de bord de gestion avec ce compte. Pour continuer, scannez le code ci-dessous avec votre application Authenticator, comme Google Authenticator.",
        "2fa_code": "Code",
        "2fa_enable": "Activer",
        "2fa_enabled": "Authentification à deux facteurs activée",
        "2fa_enable_failed": "L'activation de l'authentification à deux facteurs a échoué",
        "2fa_already_enabled": "L'authentification à deux facteurs est déjà activée sur votre compte. Pour la désactiver, saisissez votre code d'authentification à deux facteurs ci-dessous. Les codes de récupération générés lors de la configuration de l'authentification à deux facteurs peuvent également être utilisés pour la désactiver.",
        "2fa_disabled": "L'authentification à deux facteurs a été désactivée avec succès",
        "2fa_disable_failed": "Échec de la désactivation de l'authentification à deux facteurs",
        "2fa_disable": "Désactiver",
        "2fa_recovery_codes": "Codes de récupération :",
        "2fa_recovery_codes_copied": "Codes de récupération copiés dans le presse-papiers",
        "customer_passwordless_disabled_tooltip": "Connexion sans mot de passe désactivée sur le client"
      }
    },
    "customers": {
      "text": {
        "title": "Clients",
        "alarmcenter_queueName": "File d'attente du centre d'alarme (demandez à Jesse ou Luuk)",
        "alarmcenter_title": "Centres d'alarme",
        "update_success": "Mise à jour client",
        "uuid_validation": "Doit être un UUID valide",
        "title_single": "Client",
        "create_success": "Client créé !",
        "create_preview_title": "Sera créé",
        "create_preview": {
          "customer": "Client",
          "structure": "Structure",
          "triggers": "Déclencheurs d'observation",
          "ats": "Liens client ATS",
          "qr": "Enregistrement QR",
          "reports": "Rapports",
          "bhvk_merge": "Fusion désactivée ; même sévérité + type ; fenêtre 15 min ; ATS retrigger 5 min",
          "bhvk_no_relations": "Pas de parent / centre d'alarme / partenaires / facturation",
          "bhvk_ats_button": "BHV-Knoppen → modèle alerte pairs BHV (rouge + orange)",
          "bhvk_ats_other": "Tous sauf groupes de boutons → rouge/orange, vert, tous les modèles",
          "bhvk_qr": "QR Legacy Main avec groupe de config BHV-Knop.nl et groupe d'assets BHV",
          "bhvk_report_alarms": "Alarmes rouges hebdomadaires (thème bhvk, destinataires vides)",
          "bhvk_report_inactivity": "Moniteur d'inactivité 40h sur groupes de boutons (thème bhvk, destinataires vides)",
          "xgac_ats": "Rouge+orange, vert, tous (3 liens)",
          "bhvk_ats_paniek": "Paniekknoppen → modèle alerte pairs AIT (rouge + orange)"
        }
      },
      "fields": {
        "locale": "Lieu",
        "responsePartner": "Est un partenaire de réponse",
        "responsePartners": "Partenaires de réponse",
        "responsePartner_name": "Partenaire de réponse",
        "alarmCenter_name": "Centre d'alarme",
        "alarmcenter_relation": {
          "enabled": "Activé"
        },
        "mergeConfig": {
          "enabled": "Activer la fusion des alarmes",
          "maxTimeBetweenAlarmsMs": "Temps maximum entre les alarmes (secondes)",
          "retriggerAtsAfterMs": "Redéclencher l'ATS après un certain temps (secondes)",
          "onlyMergeWhenSame": "Fusionner uniquement lorsqu'un (ou plusieurs) de ces champs sont identiques",
          "use_default": "Utiliser la configuration de fusion par défaut"
        },
        "alarmAgeLimit": "Alarmes visibles pour",
        "hasAlarmAgeLimit": "A un âge limité pour les alarmes visibles",
        "kiosk_config": {
          "what_groups": "Quels groupes d’actifs souhaitez-vous afficher ?",
          "what_labels": "Quelles étiquettes souhaitez-vous afficher ?",
          "which_functions": "Quelles fonctions souhaitez-vous activer ?",
          "show_alarms": "Afficher les alarmes",
          "manage_availability": "Gérer la disponibilité",
          "screen_schedule": "Horaire des projections",
          "incident_counter": "Compteur d'incidents",
          "front_page": "Page d'accueil",
          "anonymise_data": "Anonymiser les données",
          "incident_counter_count_from_date": "Compter à partir de la date",
          "incident_counter_threshold": "Seuil (Masquer le compteur en cas d'incident récent)",
          "incident_counter_threshold_helper_text": "Si aucune date n’est fixée, les jours depuis le dernier incident sont comptés.",
          "manage_availability_pin": "Code PIN",
          "manage_availability_app_hint": "Afficher l'astuce : Installer l'application",
          "manage_availability_show_search": "Toujours afficher la saisie de recherche",
          "manage_availability_show_label_filter": "Toujours afficher le filtre d'étiquette",
          "alarm_audio": "Faire du bruit avec l'alarme",
          "alarm_flash": "Écran flash par alarme",
          "alarm_show_position_labels": "Afficher la position de l'alarme sur la carte",
          "alarm_anonymous": "Anonymiser les données",
          "alarm_mode": "Mode alarme",
          "alarm_acknowledge": "Reconnaître l'alarme",
          "alarm_acknowledge_pin": "Code d'acquittement des alarmes",
          "asset_inside_zones": "Afficher uniquement les actifs à l'intérieur des zones",
          "hardware": "Matériel",
          "screen_brightness": "Luminosité de l'écran",
          "countAssets": "Groupes d'actifs à inclure dans le compteur",
          "flash": "Éclair",
          "logo": "Logo visible",
          "schedule_entries": "Quand faut-il allumer l'écran ?",
          "anonymise_data_description": "Vous souhaitez afficher les noms complets (et éventuellement les photos) sur la page d'accueil de votre kiosque ? Seuls les compteurs sont affichés sur la version anonyme du kiosque.",
          "what_groups_description": "Votre organisation peut contenir différents groupes de personnes. Sélectionnez les groupes pertinents à afficher sur ce kiosque.",
          "logo_description": "Si vous ne téléchargez pas de logo, le logo par défaut X-Guard ou BHV-Knop.nl est visible sur le kiosque.",
          "manage_availability_description": "Voulez-vous utiliser ce kiosque pour gérer la disponibilité ? Cette fonctionnalité n'est utile que dans les kiosques équipés d'un écran tactile ou d'une souris.",
          "manage_availability_pin_description": "Vous pouvez éventuellement protéger la disponibilité des modifications avec un code PIN. Laissez ce champ vide pour ne pas exiger de code PIN.",
          "show_alarms_description": "Vous souhaitez afficher les alarmes actives sur le kiosque ? Cela peut aider votre personnel à localiser l'emplacement de l'alarme et à s'y rendre le plus rapidement possible.",
          "alarm_anonymous_description": "En cas d'alarme, nous indiquons qui est appelé et qui a accepté de répondre à l'alarme. Vous pouvez choisir d'anonymiser ces données.",
          "flash_description": "Un clignotement se produit lors d'une situation d'alarme.",
          "alarm_acknowledge_description": "Cette fonctionnalité vous permettra d'utiliser ce kiosque pour résumer rapidement ce qui s'est passé et accuser réception de l'alarme.",
          "alarm_acknowledge_pin_description": "Souhaitez-vous protéger l'acquittement des alarmes avec un code PIN ?",
          "incident_counter_description": "Pour encourager un environnement de travail sûr, vous pouvez afficher un compteur d’incidents sur la page d’accueil de votre kiosque.",
          "incident_counter_count_from_date_description": "À partir de quelle date souhaitez-vous que le compteur d'incidents commence ? Vous pouvez choisir entre la date de la dernière alarme et une date fixe que vous indiquez vous-même.",
          "screen_schedule_description": "Pour protéger l'écran du kiosque, vous pouvez activer la programmation de l'écran. En dehors de la programmation définie, l'écran s'éteindra.",
          "schedule_entries_description": "En dehors de ces horaires, l'écran sera noir. Toucher l'écran activera le kiosque, même en dehors des horaires.",
          "manage_availability_pin_error": "Le code PIN doit comporter entre 4 et 6 caractères.",
          "sound_description": "En cas d'alarme, un signal sonore fort est émis. Veuillez noter que la fonction d'alarme sonore n'est disponible que sur les bornes préprogrammées BHV-Knop.nl.",
          "sound": "Son",
          "alarm_sound": "Choisissez votre son",
          "alarm_sound_description": "Le son que vous souhaitez émettre en cas d'alarme est entièrement à votre discrétion. Vous pouvez choisir entre un son qui ressemble à celui d'une alarme incendie ou un son très doux.",
          "alarm_sound_volume": "Volume sonore",
          "alarm_sound_volume_description": "Nous recommandons un volume à 100 %, mais lorsque celui-ci est trop fort à votre goût, vous pouvez l'ajuster ici.",
          "alarm_sound_stop_after_touch": "Arrêter le son au toucher",
          "alarm_sound_stop_after_touch_description": "Le kiosque arrêtera de jouer le son de l'alarme lorsque vous toucherez l'écran.",
          "alarm_sound_stop_after_seconds": "Arrêter le son après...",
          "alarm_sound_stop_after_seconds_description": "Après combien de secondes souhaitez-vous que le son de l'alarme s'arrête ? Vous pouvez également choisir de le répéter jusqu'à ce que l'alarme soit reconnue.",
          "count_label_separately": "Compteur par groupe",
          "count_label_separately_description": "Il est possible de compter par groupe sélectionné au lieu d'afficher le nombre total.",
          "alarm_mode_description": "Le mode d'alarme détermine si les alarmes sont affichées uniquement pour la zone dans laquelle se trouve le kiosque ou pour toutes les alarmes de ce compte.",
          "alarm_modes": {
            "zoneBased": "Afficher les alarmes dans la zone",
            "customerBased": "Afficher les alarmes dans le client"
          }
        },
        "disableAutomaticGenerationOfButtonZones": "Désactiver la génération automatique des zones de boutons",
        "alarmCenter": {
          "phoneNumber": "Numéro de rappel du centre d'alarme"
        },
        "userPolicies": {
          "disablePasswordlessLogin": "Désactiver la connexion sans mot de passe pour les utilisateurs"
        },
        "securityInventoryEnabled": "Inventaire de sécurité activé",
        "recurringTasksEnabled": "Tâches récurrentes activées",
        "enableZoneEnterExitEvents": "Activer les événements d'entrée/sortie de zone",
        "customerProduct": {
          "label": "Type de client",
          "xgac": "X-Guard",
          "bhvk": "BHV-knop.nl"
        }
      }
    },
    "tags": {
      "text": {
        "title": "Étiqueter"
      }
    },
    "devices": {
      "text": {
        "title": "Appareils",
        "types": {
          "lora": "Lora",
          "appDevice": "appareil d'application",
          "flic": "Flic",
          "generic": "Générique",
          "loraGateway": "Passerelle Lora"
        },
        "no_lora_config": "Aucune configuration lora spécifique",
        "error_getting_devices": "Erreur lors de l'obtention des appareils",
        "result": "Résultat",
        "downLink_explanation": "Envoyer une charge utile Hex pour les appareils IoTracker connectés au réseau KPN",
        "buttons": "Boutons"
      },
      "fields": {
        "deviceId": "ID de l'appareil",
        "type": "Taper",
        "loraConfig": {
          "type": "Type d'appareil Lora",
          "fieldtest": "Code d'observation du test sur le terrain",
          "beaconScan": "Code d'observation de la balise",
          "gps": "Code d'observation GPS",
          "preMandown": "Code d'observation avant ManDown",
          "mandown": "Code d'observation ManDown",
          "alarmSeverity": "Code d'observation d'alarme",
          "alive": "Code d'observation vide",
          "floodDetected": "Code d'observation de détection d'inondation",
          "noFloodDetected": "Aucun code d'observation d'inondation détectée",
          "type_help": "Assurez-vous que le type d'appareil sélectionné est correct. Si le type d'appareil est incorrect, la configuration modifiée ne sera pas utilisée.",
          "movement": "Code d'observation des mouvements"
        },
        "battery": "Batterie"
      },
      "actions": {
        "downLink": "Liaison descendante"
      }
    },
    "flic-buttons": {
      "text": {
        "invalid_hub_id": "ID de hub non valide",
        "title": "Boutons Flic",
        "found_button": "Bouton trouvé !",
        "config": {
          "title": "Utilisez la configuration suivante pour le bouton :",
          "single_click_title": "Événement en un seul clic",
          "single_click_description": "Bouton de mise à jour méta-info",
          "double_click_title": "Événement de double clic",
          "double_click_description": "Reconnaître (fermer) la dernière alarme déclenchée par le même actif",
          "hold_title": "Organiser un événement",
          "hold_description": "Créer une alarme selon la configuration ci-dessus",
          "hub_action": "Action du moyeu",
          "internet_request": "Demande Internet",
          "url": "URL",
          "method": "Méthode",
          "method_post": "POSTE",
          "description": "Description"
        },
        "waiting_for_press": "En attente d'appuyer sur le bouton",
        "test_mode_active_until": "Mode test actif jusqu'à",
        "activate_test_mode": "Activer le mode test",
        "test_mode": "Mode test"
      },
      "fields": {
        "action": "Action",
        "serial": "En série",
        "battery": "Batterie",
        "deleted": "Supprimé"
      }
    },
    "flic-hubs": {
      "text": {
        "title": "Moyeux Flic"
      },
      "fields": {
        "alarmLevel": "Niveau d'alarme",
        "xgacCustomerId": "Client"
      },
      "go_to_buttons": "Boutons"
    },
    "observation-triggers": {
      "text": {
        "title": "Déclencheurs d'observation",
        "general": "Général",
        "action_config": "Configuration d'action",
        "add_action": "Ajouter une action",
        "add_eventcode": "Ajouter un code d'événement",
        "filter": "Filtre"
      },
      "fields": {
        "eventCodes": "Codes d'événements",
        "description": "Description",
        "active_status": "Statut actif",
        "type": "Taper",
        "config": {
          "\u0000": "Configuration",
          "available_false": "Indisponible",
          "toContactList": "Listes de contacts",
          "toRaw": "Destinataires",
          "available_true": "Disponible",
          "customer_default": "Valeur par defaut du client",
          "toTriggerUser": "Utilisateur declencheur",
          "do_not_change": "Ne pas modifier"
        },
        "filter_type": "Type de filtre",
        "action_type": "Type d'action",
        "schedule_entries": "Creneaux du planning",
        "days": "Jours",
        "operands": "Conditions",
        "operand": "Condition",
        "timeStart": "Heure de debut",
        "timeEnd": "Heure de fin",
        "match": "Correspondance",
        "condition_block": "Bloc de conditions"
      },
      "action_types": {
        "alarm": "Alarme",
        "sms": "SMS",
        "email": "E-mail",
        "assetUpdate": "Mettre a jour l'asset"
      },
      "filter_types": {
        "operator_or": "Une des conditions",
        "constraint_assetGroup": "Groupe d'assets",
        "operator_and": "Toutes les conditions",
        "constraint_asset": "Asset",
        "constraint_zone": "Zone",
        "operator_not": "Non",
        "constraint_schedule": "Planning",
        "operator_none": "Aucune condition"
      },
      "validation": {
        "time": "Saisissez une heure valide (HH:mm)"
      },
      "match_types": {
        "matches": "Correspond",
        "does_not_match": "Ne correspond pas"
      }
    },
    "overlays": {
      "text": {
        "title": "Superpositions",
        "overlay_not_found": "Superposition non trouvée ou non modifiée",
        "create": "Ajouter une nouvelle superposition",
        "delete_dialog_title": "Supprimer la superposition",
        "delete_dialog_content": "Etes-vous sûr de vouloir supprimer cette superposition ?",
        "add_marker": "Ajoutez un marqueur en cliquant sur l'emplacement souhaité sur la carte pour continuer la création.",
        "place_marker": "Placez le marqueur au centre du bâtiment"
      },
      "fields": {
        "image": "Recouvrir",
        "image_url": "URL de l'image",
        "points": "Points"
      },
      "notifications": {
        "overlay_too_small": "Superposition trop petite, veuillez la modifier pour l'agrandir."
      }
    },
    "qr-templates": {
      "text": {
        "title": "Modèles de codes QR",
        "mail_recipient_types": {
          "asset": "actif",
          "manual": "manuel"
        },
        "generating_qr": "Génération du QR, veuillez patienter...",
        "code_created": "Code créé",
        "code_created_failed": "Code non créé",
        "code_updated": "Code mis à jour",
        "code_updated_ failed": "Code non mis à jour",
        "code_deleted": "Code supprimé",
        "code_deleted_failed": "Code non supprimé",
        "options": "Options",
        "default_qr": "QR par défaut",
        "brochure_nl": "Brochure NL",
        "brochure_en": "Brochure FR",
        "field": "Champ",
        "value": "Étiquette Sjabloon",
        "locked": "Fermé",
        "external_id": "ID externe",
        "first_name": "Prénom",
        "last_name": "Nom de famille",
        "user_email": "Courriel de l'utilisateur",
        "phone_prefix": "Préfixe téléphonique du pays",
        "phone_number": "Numéro de téléphone",
        "available": "Disponible",
        "limit": "Limite",
        "save_first": "Enregistrez d'abord avant d'ajouter des codes",
        "codes": "Codes",
        "actions_save_first": "Pour ajouter des actions, enregistrez d'abord",
        "registering_title": "Inscription en cours... Veuillez patienter",
        "uploading": "Téléchargement du fichier, veuillez patienter...",
        "download_qr": "Télécharger ou prévisualiser le QR",
        "preview": "Voir",
        "single_title": "Modèle de QR",
        "sends_email": "Envoie un e-mail",
        "paused": "En pause",
        "pause_throttle": "Suspendre l'anti-spam",
        "pause_throttle_explanation": "Si vous vous inscrivez avec un groupe, cliquez sur le bouton ci-dessous. L'inscription de groupe sera possible pendant une heure.",
        "end_pause_throttle": "Réactiver la sécurité maintenant"
      },
      "fields": {
        "group_list": "Liste des groupes",
        "recipient_type": "Type de destinataire",
        "template_label": "Étiquette du modèle",
        "template_value": "Valeur du modèle",
        "recipient_list": "Liste des destinataires",
        "template_updated": "Modèle mis à jour",
        "template_update_failed": "Modèle non mis à jour",
        "pages": "Pages",
        "visible": "Visible",
        "actions": "Actes"
      }
    },
    "service-accounts": {
      "text": {
        "title": "Comptes de service",
        "username_validation": "Le nom d'utilisateur du compte de service doit commencer par « sa- »"
      }
    },
    "static-responders": {
      "text": {
        "title": "Répondeurs statiques",
        "days": {
          "monday": "Lundi",
          "tuesday": "Mardi",
          "wednesday": "Mercredi",
          "thursday": "Jeudi",
          "friday": "Vendredi",
          "saturday": "Samedi",
          "sunday": "Dimanche",
          "all": "Tous les jours",
          "weekdays": "Jours ouvrables",
          "weekends": "Les week-ends"
        },
        "general": "Général",
        "contact_options": "Options de contact",
        "availability": "Disponibilité",
        "professional_response": "Réponse professionnelle",
        "postcodes": "Codes postaux"
      },
      "fields": {
        "schedule_entry_add": "Ajouter une entrée de planification",
        "contact": {
          "camera": "Caméra"
        },
        "externalId": "ID externe",
        "schedule": {
          "name": "Calendrier",
          "entries": "Entrées de planification"
        },
        "days_of_week": "Jours de la semaine",
        "time_start": "Début de l'heure",
        "time_end": "Fin du temps",
        "integrations": {
          "sequrix": {
            "enabled": "Séqurix",
            "objectCode": "Code objet"
          }
        }
      },
      "notifications": {
        "postcodes_updated": "Répondeurs statiques mis à jour sur la zone %{smart_count} |||| Répondeurs statiques mis à jour sur les zones %{smart_count}",
        "no_changes": "Aucun changement n'a été constaté chez les répondants",
        "invalid_postcode": "Code postal invalide, veuillez réessayer"
      }
    },
    "webhooks": {
      "text": {
        "title": "Webhooks",
        "entity": "Entité",
        "filter_explanation": "Filtre Webhook (format de requête Mongo)",
        "delivery": "Livraison",
        "enabling": "Activation",
        "output_preview": "Aperçu de la sortie"
      },
      "fields": {
        "enableWebhook": "Webhook activé",
        "webhookQuery": {
          "operation": "Opération",
          "entityTypes": "Types d'entités",
          "filter": "Filtre"
        },
        "deliveryConfig": {
          "method": "Méthode",
          "url": "URL",
          "headers": "En-têtes"
        },
        "deliveryStats": {
          "numDeliverySucceeded": "Nombre d'accouchements réussis",
          "numDeliveryFailed": "Nombre de livraisons échouées",
          "lastDeliveryDate": "Dernière livraison réussie"
        }
      }
    },
    "zones": {
      "text": {
        "zoneTypes": {
          "default": "Défaut",
          "response_area": "Zone de réponse",
          "police_department": "Service de police",
          "fingerprinted": "Empreinte digitale",
          "assetMonitoredArea": "Zone de surveillance des actifs",
          "building": "Bâtiment",
          "evacuationPoint": "Point d'évacuation"
        },
        "title": "Zones",
        "polygon_should_smaller": "La zone du polygone doit être plus petite qu'un seul hémisphère",
        "one_figure_per_zone": "Vous ne pouvez ajouter qu'une seule figurine par zone.",
        "invalid_zone": "La zone n'est pas valide : Plus ou moins d'un chiffre.",
        "title_single": "Zone",
        "invalid_zone_intersection": "La zone n'est pas valide : a une auto-intersection.",
        "syncToAms_explanation": "Lorsqu'elle est activée, cette zone est utilisée comme zone AMS, ce qui permet aux appareils de déclencher différentes actions lors de l'entrée/sortie de la zone.\nActuellement pertinent uniquement pour la commutation de la disponibilité de BHV-Knop.nl. Cela sera développé ultérieurement.",
        "beacons_in_zone": "Balises liées",
        "assets_inside": "Il y a actuellement %{smart_count} personne dans cette zone |||| Il y a actuellement %{smart_count} personnes dans cette zone",
        "updated": "Zone mise à jour !",
        "assets_inside_dialog_title": "Personnes à l'intérieur de cette zone",
        "zone_list": "Liste des zones",
        "manage": "Gérer les zones",
        "created": "Zone créée !",
        "delete": "Supprimer la zone",
        "deleted": "Zone supprimée",
        "create_mode_dialog_title": "Souhaitez-vous créer cette zone comme un point sur la carte ou comme une zone ?",
        "area": "Zone",
        "area_subtext": "Dessiner une zone fermée sur la carte",
        "marker": "Point sur la carte",
        "marker_subtext": "Un point sur la carte.\nAdapté à la localisation avec les balises X-Guard",
        "edit_warning": "Vous êtes en train de modifier une zone. Enregistrez ces modifications ou annulez-les.",
        "still_editing_warning": "Vous êtes en train de modifier une zone. Enregistrez ces modifications ou annulez-les.",
        "assets_inside_empty": "Il n'y a actuellement personne dans cette zone",
        "create_dialog_where_title": "Où souhaitez-vous placer cette zone ?",
        "create_dialog_where_map": "Je choisirai manuellement la position sur la carte",
        "create_dialog_where_input": "Sur une adresse",
        "delete_disabled_ams_or_beacons": "Cette zone est utilisée dans la configuration interne avancée et ne doit pas être supprimée.",
        "delete_disabled_links_or_triggers": "Cette zone est utilisée dans la configuration interne avancée et ne doit pas être supprimée.",
        "zones_with_similar_prints": "Il y a %{smart_count} paires de zones avec des données similaires, cliquez pour en voir plus |||| Il y a %{smart_count} paires de zones avec des données similaires. Cliquez pour en voir plus",
        "customers_with_same_codes": "Codes de balise trouvés dans les empreintes digitales dans différents environnements clients. Cliquez pour en savoir plus",
        "zones_with_similar_prints_title": "Zones avec des empreintes similaires",
        "customers_with_same_codes_title": "Clients avec les mêmes codes imprimés",
        "not_fingerprinted_zones": "Zones avec peu ou pas d'empreintes digitales",
        "zones_with_bad_prints": "Il y a 1 zone avec des empreintes digitales qui n'ont pas assez de balises pour être de qualité. Cliquez pour en voir plus. |||| Il y a %{smart_count} zones avec des empreintes digitales qui n'ont pas assez de balises pour être de qualité. Cliquez pour en voir plus.",
        "zones_with_bad_prints_title": "Zones avec de mauvaises empreintes",
        "beacon_calc": {
          "open_button": "Citation IPS",
          "dialog_title": "Chambres calculées",
          "table": {
            "beacons": "balises",
            "room_size": "Taille",
            "room_number": "Nombre",
            "total_square_meters": "Superficie totale en m²",
            "beacon_number": "Nombre estimé de balises",
            "fingerprint_time": "Prise d'empreintes digitales",
            "beacon_place_time": "Montage des balises",
            "total_time": "Total",
            "small": "Petit",
            "medium": "Moyen",
            "large": "Grand"
          },
          "hours": "votre |||| uren",
          "minutes": "minute |||| minutes"
        },
        "add_screen_subtext": "Générer une URL d'écran",
        "no_zones": "Créez d'abord une zone",
        "delete_disabled_kiosks": "Cette zone est utilisée dans un kiosque et ne doit pas être supprimée.",
        "filter_in_bounds": "Filtrer hors de la carte",
        "update_dialog_title": "Voulez-vous mettre à jour cette zone ?",
        "update_dialog_content": "Cette zone est prise en compte. La mise à jour de cette zone peut rendre les empreintes digitales inexactes. Voulez-vous mettre à jour cette zone ?",
        "delete_disabled_fingerprinted": "Cette zone est utilisée pour la détermination de l'emplacement intérieur",
        "alarm_professional_responder_count_dialog_title": "Nombre de Sequrix par zone",
        "alarm_professional_responder_count_empty": "Impossible d'obtenir les zones"
      },
      "filters": {
        "only_show": "Afficher uniquement"
      },
      "fields": {
        "type": "Taper",
        "description": "Description",
        "number_of_responders": "Nombre de répondeurs statiques",
        "responsePriority": "Priorité de réponse",
        "number_of_beacons": "Nombre de balises",
        "number_of_assets": "Nombre d'actifs à l'intérieur de cette zone",
        "syncToAms": "Synchronisation avec AMS",
        "alarm_position": "Position de l'alarme",
        "fingerprintCount": "Comptage des empreintes digitales",
        "has_address_position": "Si cette option est activée, l'adresse saisie sera utilisée dans toute la zone marquée.",
        "postCodeRange": "Plage de codes postaux",
        "postCodeRange_helper": "Par exemple 7413-7451, 7499",
        "postCodeRange_label": "Plage de codes postaux",
        "alarm_professional_responder_count_sequrix": "Nombre de Sequrix dans la zone",
        "alarm_professional_responder_count_no_sequrix": "Nombre d'autres intervenants dans la zone",
        "alarm_professional_responder_count_responders": "Comte Séqurix"
      }
    },
    "contact-lists": {
      "text": {
        "title": "Listes de contacts",
        "contacts_number": "Nombre de contacts"
      },
      "fields": {
        "contacts": "Contacts"
      }
    },
    "report-triggers": {
      "text": {
        "title": "Déclencheurs de rapport",
        "granularity_types": {
          "minute": "minutes)",
          "hour": "heures)",
          "day": "jours)",
          "week": "Semaine(s)",
          "month": "Mois)",
          "quarter": "Trimestre(s)",
          "year": "Années)"
        },
        "config_types": {
          "unhealthyBeacons": "Balises malsaines",
          "observation": "Nombre d'observations",
          "alarms": "Alarmes",
          "newAlarm": "Nouvelle alarme",
          "inactivityMonitor": "Moniteur d'inactivité",
          "appUsage": "Utilisation de l'application",
          "assetHistory": "Historique des actifs",
          "alarmCenterStatus": "État du centre d'alarme",
          "zoneOverview": "Aperçu de la zone",
          "subtext": {
            "alarms": "Le rapport d'alarme envoie un rapport contenant un aperçu des alarmes déclenchées depuis le dernier rapport. Lorsque cette option est activée, le rapport est envoyé le lundi suivant, puis %{interval} après cela.",
            "appUsage": "Le rapport d'utilisation de l'application envoie un rapport contenant un aperçu de l'utilisation de l'application par utilisateur au cours du dernier mois. Lorsque cette option est activée, le rapport est envoyé au début du mois, chaque mois.",
            "inactivityMonitor": "Le rapport de surveillance d'inactivité se déclenche lorsqu'un bouton n'apparaît pas en ligne pendant au moins 24 heures. Cela indique que le bouton ne fonctionne pas correctement, soit en raison d'une batterie faible, soit en raison d'un défaut physique. L'e-mail envoyé indiquera les étapes de suivi.",
            "unhealthyBeacons": "Le rapport de balises défectueuses contient des balises qui n'ont pas été vues récemment ou dont la batterie restante est faible. Il est envoyé %{interval}.",
            "alarmCenterStatus": "Le rapport d'état du centre d'alarme contient des informations sur le nombre d'alarmes transmises au centre d'alarme.",
            "newAlarm": "Le nouveau rapport d'alarme est envoyé lorsqu'une nouvelle alarme est créée. Il n'est pas envoyé pour les alarmes de test."
          }
        },
        "config": {
          "excel_types": {
            "default": "Défaut",
            "smc": "SMC"
          }
        },
        "channel_types": {
          "contact_list": "Liste de contacts"
        },
        "go_contactlist": "Cliquez pour accéder à la ou aux listes de contacts.",
        "licence_modes": {
          "hourlyUsage": "Utilisation horaire",
          "license": "Licence"
        },
        "filter_tags": {
          "active": "Actif",
          "inactive": "Inactif",
          "new": "Nouveau",
          "forgotten": "Oublié"
        },
        "invalid_email": "Un ou plusieurs email(s) invalide(s)",
        "not-exists": "Le déclencheur n'existe plus",
        "theme": {
          "default": "Par défaut (X-Guard)",
          "bhvk": "Bouton BHV.nl"
        },
        "send-for-current-month": "Envoyer également pour le mois en cours",
        "send-current-month-unavailable": "Ce rapport ne peut plus être envoyé pour ce mois.",
        "unsubscribedEmails_helper": "Les adresses dans ce champ ne recevront pas ce rapport."
      },
      "fields": {
        "config": {
          "type": "Taper",
          "last_seen_threshold": "Dernier seuil vu",
          "excelFormat": "Format Excel",
          "alarmTypes": "Types d'alarme",
          "timeSeries_title": "Séries chronologiques",
          "severities": "Gravités d'alarme",
          "timeSeries": {
            "granularity": "Granularité",
            "timeframe": "Laps de temps"
          },
          "app_mode": "Mode application",
          "timeout": "Temps mort",
          "floorTo": "Du sol au",
          "agOptions": {
            "includeRaw": "Inclure les matières premières",
            "includeSimple": "Inclure simple"
          },
          "excludeCustomers": "Exclure les clients"
        },
        "enabled": "Activé",
        "lastRunAt": "Dernière course à",
        "nextRunAt": "Prochaine course à",
        "runInterval_title": "Intervalle d'exécution",
        "channels": "Chaînes",
        "channels_type": "Taper",
        "channels_address": "Adresses e-mail",
        "time_granularity": {
          "value": "Montant",
          "type": "Temps"
        },
        "channels_number": "Numéros de téléphone",
        "lastAttemptedAt": "Dernière tentative à",
        "unsubscribedEmails": "Adresses e-mail désabonnées"
      }
    },
    "unhealthyBeacons": {
      "text": {
        "inactive": {
          "label": "Balises inactives"
        },
        "lowBattery": {
          "label": "Balises de batterie faible"
        },
        "noneFound": "Aucune balise trouvée chez ce client",
        "noAttachments": "Aucune pièce jointe trouvée."
      }
    },
    "lite-templates": {
      "name": "Codes QR"
    },
    "app_users": {
      "text": {
        "groups_and_config_explanation": "Sélectionnez les groupes et la configuration ci-dessous. Si vous le souhaitez, un modèle QR peut être sélectionné comme base. Les groupes et la configuration choisis peuvent être définis sur tous les utilisateurs d'application sélectionnés. Pour les groupes et la configuration, un choix peut être fait entre le remplacement des valeurs existantes, l'ajout de valeurs existantes ou l'omission des groupes ou de la configuration. Lorsque l'omission est sélectionnée, les valeurs ne seront pas modifiées."
      }
    },
    "domainlinks": {
      "title": "Restrictions de domaine"
    },
    "domainlink": {
      "fields": {
        "domain": "Domaine"
      }
    },
    "buttons": {
      "text": {
        "manage_buttons": "Gérer les boutons",
        "search": "Rechercher des appareils",
        "show_all": "Afficher tous les boutons",
        "coordinates_small": "(faites glisser le point sur la carte)",
        "gateway_map_disclaimer": "Le cercle autour d’une station de base n’est qu’une indication de portée.",
        "mass_move_title": "Déplacer plusieurs boutons",
        "move_confirm_button": "Se déplacer",
        "mass_move_explanation": "Choisissez l'adresse",
        "button_number_tooltip": "Le numéro du bouton est imprimé sur un autocollant en bas",
        "gateway_number_tooltip": "Le numéro de la passerelle est imprimé au dos de l'appareil",
        "test_button_title": "Vous recevrez une notification",
        "test_button_content": "Cette notification vous sera adressée uniquement, pas à tous les membres du BHV disponibles. Si vous souhaitez effectuer un test avec tout le personnel disponible, appuyez sur le bouton.",
        "test_sent": "Test envoyé, vous recevrez cette alarme via un appel",
        "test_disabled": "Test désactivé car l'utilisateur connecté n'a pas de méthode valide pour recevoir l'alarme",
        "print_all_labels": "Imprimer toutes les étiquettes",
        "print_all_labels_confirm": "Êtes-vous sûr de vouloir imprimer toutes les étiquettes ?",
        "sufficient_battery": "Batterie suffisante",
        "show_buttons": "Afficher les boutons",
        "building_dialog": {
          "0": {
            "title": "Ajouter un bâtiment",
            "explanation": "Sur la base de l'adresse trouvée, nous essaierons automatiquement de charger votre bâtiment avec les données disponibles du plan cadastral.",
            "input_label": "Rechercher l'adresse...",
            "input_upper_label": "Recherchez votre adresse complète"
          },
          "1": {
            "title": "Bâtiment trouvé",
            "explanation": "Nous avons trouvé un bâtiment. Est-ce votre bâtiment ? Si ce n'est pas le cas, sélectionnez le bâtiment approprié sur la carte et continuez.",
            "surface_area": "Superficie %{area} m²",
            "next_button": "Continuer avec le bâtiment sélectionné |||| Continuer avec les bâtiments sélectionnés",
            "building_count": "%{smart_count} bâtiment |||| %{smart_count} bâtiments"
          },
          "2": {
            "title": "Bâtiment %{building} de %{max}",
            "how_many_floors": "Combien d'étages compte le bâtiment ?",
            "floors": "Planchers",
            "next_button": "Voir la proposition",
            "next_builing_button": "Bâtiment suivant",
            "office_or_factory": "Qu'est-ce qui décrit le plus précisément ce bâtiment ?",
            "office": "Bureau",
            "factory": "Usine ou halle",
            "button_distance_title": "Distance de marche maximale jusqu'à un bouton",
            "button_distance_sub_title": "Nous conseillons une distance de 30 mètres.",
            "button_distance_button": "%{distance} mètre",
            "recommended": "Recommandé"
          },
          "3": {
            "title": "Notre proposition",
            "next_button": "Ajouter les produits",
            "view_price": "Montre-moi le prix"
          },
          "no_streetnumber": "Aucun numéro de rue trouvé pour l'adresse choisie",
          "change_later": "Vous pouvez facilement modifier cela plus tard",
          "building": "Bâtiment",
          "not_in_countries": "Veuillez sélectionner une adresse aux Pays-Bas ou en Flandre.",
          "max_buildings": "Il est recommandé de ne pas ajouter plus de %{count} bâtiments à la fois",
          "no_buildings_found": "Aucun bâtiment trouvé à l'adresse fournie"
        },
        "map_default": "Carte",
        "map_satellite": "Satellite",
        "map_center": "Centre",
        "floors_chosen": "Étages sélectionnés",
        "all_floors": "Tous les étages",
        "actions_with_selected": "Actions avec sélection",
        "mass_move": "Se déplacer",
        "add_gateway": "Ajouter une passerelle",
        "add_button": "Bouton Ajouter",
        "create_dialog_title_gateway": "Où souhaitez-vous placer cette passerelle ?",
        "create_dialog_title_button": "Où souhaitez-vous placer ce bouton ?",
        "how_many_gateways": "Combien de passerelles souhaitez-vous ajouter ?",
        "how_many_buttons": "Combien de boutons souhaitez-vous ajouter ?",
        "no_concept_devices": "Aucun bouton ou passerelle d'urgence non payé n'a été trouvé dans vos appareils sélectionnés",
        "unpaid_devices": "Vous avez des produits impayés",
        "delete_unpaid": "Supprimer ces produits",
        "deleted_unpaid_devices": "Appareils non payés supprimés",
        "delete_are_you_sure": "Êtes-vous sûr de vouloir supprimer ces appareils non payés ?",
        "delete_add_again": "Ces appareils peuvent être facilement ajoutés à nouveau.",
        "deleted_unpaid_devices_error": "Une erreur s'est produite lors de la suppression des appareils sélectionnés.",
        "not_ordered": "Pas encore commandé",
        "place_button": "Placer le(s) bouton(s)",
        "place_gateway": "Placer la ou les passerelles",
        "stop_placing": "Arrêtez de placer des appareils",
        "status": {
          "online": "Cet appareil est en ligne",
          "offline": "Cet appareil est hors ligne",
          "pending": "L'état de cet appareil est en cours de récupération",
          "empty": "La batterie de cet appareil est (presque) vide",
          "lowRSSI": "Trop loin",
          "highNoise": "Le signal radio est bruyant",
          "nobody_why": "Personne contacté, lisez pourquoi ici"
        },
        "deviceType": "Type d'appareil",
        "remove_filters": "Supprimer les filtres",
        "save_filters": "Enregistrer les filtres",
        "active_status_label": "Statut actif",
        "active_status": {
          "active": "Dispositifs commandés et actifs",
          "unpaid": "Appareils non payés",
          "demo": "Appareils de démonstration"
        },
        "all_devices": "Tous types d'appareils",
        "devices_chosen": "Types d'appareils choisis",
        "all_active_status": "Tous les statuts",
        "active_status_chosen": "Statut choisi",
        "building_distance_warning": "Les bâtiments sélectionnés sont éloignés les uns des autres. Vérifiez si ces bâtiments appartiennent à « %{address} ». Il est possible d'ajouter une autre adresse en ajoutant un autre bâtiment lorsque vous avez terminé avec celui en cours.",
        "create_alarm_uncontacted": "%{smart_count} personne non contactée auparavant |||| %{smart_count} personnes non contactées auparavant",
        "invalid_address": "Nous n'avons pas pu trouver cette adresse aux Pays-Bas. Vous pouvez ajouter des adresses en dehors des Pays-Bas en plaçant un bouton d'intervention d'urgence distinct sur votre bâtiment.",
        "locked": "Fermé",
        "unlocked": "Débloqué",
        "create_alarm_confirm_title": "Êtes-vous sûr de vouloir créer une alarme pour ce bouton ?",
        "create_alarm_current_address": "Adresse actuelle:",
        "print_selected_labels": "Imprimer les étiquettes sélectionnées",
        "print_selected_labels_confirm": "Êtes-vous sûr de vouloir imprimer les étiquettes sélectionnées ?",
        "print_selected_labels_notify": "Les étiquettes sélectionnées seront imprimées",
        "print_all_labels_notify": "Toutes les étiquettes sont imprimées",
        "no_labels_selected": "Aucune étiquette avec un identifiant valide n'a été sélectionnée pour l'impression.",
        "print_labels_error": "Erreur lors de l'impression des étiquettes"
      },
      "fields": {
        "address": "Adresse textuelle"
      },
      "automove_title": "Déplacer automatiquement les boutons",
      "groups_selected": "Groupes sélectionnés",
      "automove_no": "Non, conserver la position actuelle"
    },
    "notifications": {
      "move_multiple_no_location": "Veuillez sélectionner un emplacement avant de cliquer sur Déplacer",
      "moved_multiple": "Boutons et/ou passerelles déplacés.",
      "moved_multiple_error": "Erreur lors du déplacement, un ou plusieurs peuvent ne pas être déplacés."
    },
    "report_triggers": {
      "text": {
        "to_whom": "À qui ?",
        "specific_fields": "Champs spécifiques au type de rapport"
      },
      "what_report": "Quel rapport ?"
    },
    "roles": {
      "title": "Rôles"
    },
    "reports": {
      "title": "Rapports",
      "text": {
        "attached_email": "E-mail généré",
        "show_email": "Afficher l'e-mail",
        "sub_title": "Les différents rapports sont disponibles sur cette page. Vous pouvez également activer/désactiver cette fonction et déterminer à qui le rapport sera envoyé. Il vous manque un rapport ? Contactez-nous.",
        "recipients": "Destinataires",
        "no_recipients": "Ce rapport ne sera envoyé à aucun destinataire. Cette configuration n'est pas correcte.",
        "confirm_dialog_content": "Êtes-vous sûr de vouloir désactiver ce rapport ?",
        "settings": "Paramètres du rapport",
        "hour": "%{smart_count} heure |||| %{smart_count} heures",
        "day": "%{smart_count} jour |||| %{smart_count} jours",
        "week": "%{smart_count} semaine |||| %{smart_count} semaines",
        "zones_no_data": "Sur cette page, vous pouvez voir qui était présent dans vos zones dans le passé.\n\nDe cette façon, vous pouvez vous assurer qu'il y avait suffisamment de personnes présentes au moment souhaité.",
        "zones_settings_title": "Rapport de disponibilité en direct",
        "zones_settings_explain": "Ce rapport montre en direct l'occupation actuelle et précédente dans les zones sélectionnées.",
        "zones_settings": {
          "zone_helpertext": "Choisissez les zones pour lesquelles vous souhaitez afficher les graphiques",
          "period_helpertext": "Choisissez la période pendant laquelle vous souhaitez revenir en arrière. Avec une période plus longue, les données affichées deviennent moins précises.",
          "period": "Période",
          "min_occupancy_helpertext": "Vous pouvez également choisir le nombre de personnes que vous souhaitez voir présentes. Il peut s'agir par exemple du nombre souhaité de personnels d'intervention d'urgence.",
          "includeGroups_helpertext": "Choisissez les groupes d’utilisateurs qui peuvent être comptabilisés comme occupation.",
          "inactivityThreshold": "Exiger une activité dans l'application",
          "occupancy_title": "Combien de personnes souhaiteriez-vous voir présentes ?",
          "schedule": "Voulez-vous définir un horaire d'occupation minimale ?",
          "zone_title": "Quelle zone souhaitez-vous surveiller ?",
          "enabled": "Notifier par email en cas de sous-effectif",
          "schedule_warning": "Vous pouvez définir différentes occupations minimales pour différents horaires",
          "asset_groups": "Quels groupes souhaitez-vous surveiller ?"
        },
        "zones_no_groups": "Il n'y a aucune zone à surveiller. Vous pouvez ajouter des zones via la page Zones.",
        "month": "%{smart_count} mois |||| %{smart_count} mois",
        "subtext_week": "chaque semaine |||| toutes les %{smart_count} semaines",
        "subtext_month": "tous les mois |||| tous les %{smart_count} mois",
        "subtext_day": "tous les jours |||| tous les %{smart_count} jours",
        "subtext_hour": "toutes les heures |||| toutes les %{smart_count} heures",
        "subtext_quarter": "tous les trimestres |||| tous les %{smart_count} trimestres",
        "subtext_year": "chaque année |||| tous les %{smart_count} ans",
        "add_zone": "Surveiller la nouvelle zone",
        "zone_monitor_added": "La surveillance a commencé",
        "zone_monitor_updated": "Suivi mis à jour",
        "sends_email": "Alertes par e-mail",
        "bhvk_title": "Disponibilité au cours des 7 derniers jours",
        "zone_monitor_loading_secondary": "Chargement des disponibilités, veuillez patienter...",
        "zoneOverview_filter_assets": "Afficher uniquement les personnes sélectionnées",
        "zoneOverview_filter_assets_tooltip": "Graphique filtré sur les personnes",
        "zoneOverview_asset_settings": "Sélectionnez les personnes que vous souhaitez voir apparaître sur le graphique.",
        "last_week": "La semaine dernière",
        "last_month": "Mois dernier",
        "zoneOverview_timeseries_settings": "Sélectionneur de graphiques par semaine de maand wilt zien"
      },
      "fields": {
        "attachments": "Pièces jointes",
        "last_attachments": "Afficher le dernier e-mail",
        "minOccupancy": "Occupation souhaitée",
        "occupancy": "Occupation",
        "enable_warnings": "Activer les avertissements",
        "enable_weekly": "Activer les e-mails hebdomadaires",
        "enable_monthly": "Activer l'abonnement mensuel",
        "enable_emails": "Souhaitez-vous recevoir des e-mails concernant ce graphique ?",
        "hasAttachment": "Veuillez joindre une liste des personnes qui se sont trouvées dans cette zone chaque jour."
      },
      "title_single": "Rapport"
    },
    "report-trigger-runs": {
      "title": "Rapports",
      "empty": "Aucun rapport pour le moment"
    },
    "kiosk-users": {
      "title": "Kiosques",
      "default_config": "Utilise la configuration par défaut",
      "text": {
        "config_not_set": "Configuration non définie",
        "created": "Écran utilisateur créé",
        "set_zone": "Erreur : définir une zone"
      },
      "fields": {
        "kioskConfig": {
          "managed": "Géré"
        },
        "fully_android_id": "Kiosque Android ID complet",
        "fully_device_id": "ID d'appareil entièrement kiosque",
        "managed": "Gestion X-Guard"
      },
      "url_dialog_title": "L'URL de votre kiosque",
      "url_dialog_privacy": "Je comprends que cette URL donne accès à des informations potentiellement confidentielles de mon organisation.",
      "url_dialog_show_once": "Je comprends que cette URL n'est affichée qu'une seule fois. Elle ne sera plus affichée et si je la perds, une nouvelle URL devra être générée.",
      "url_dialog_use_once": "Je comprends que cette URL ne peut être utilisée que sur un seul écran. Si vous avez plusieurs écrans, créez davantage d'écrans dans ce tableau de bord.",
      "kiosk_number": "Numéro de kiosque",
      "url_dialog_agree": "Je comprends que cela régénérera l'URL. L'ancienne URL existante ne fonctionnera plus."
    },
    "qr-code": {
      "text": {
        "single": "Code QR"
      }
    },
    "fingerprints": {
      "text": {
        "progress_zones": "Zones d'empreintes digitales",
        "progress_devices_in_fingerprint": "Appareils dans les empreintes digitales",
        "progress_beacons_in_fingerprint": "Nombre de balises dans les empreintes digitales",
        "is_similar_to": "Est similaire à",
        "similar_scans": "Scans similaires",
        "other_customer": "Autre client",
        "create_beacons": "Créer des balises pour les codes dans les empreintes digitales",
        "missing_codes": "Codes des balises manquantes",
        "create_beacons_button": "Créer des balises",
        "beacons_created": "%{smart_count} balise créée ! |||| %{smart_count} balises créées !",
        "beacons_not_created": "Les balises n'ont pas pu être créées",
        "check_beacons": "Vérifiez si des balises doivent être créées",
        "check_progress": "Vérifiez la progression et la santé des empreintes digitales",
        "disable_statistics": "Désactiver la progression et la santé",
        "change_zones": "Changer de zone",
        "bulk_action_buttons_title": "Modifier les zones des empreintes digitales sélectionnées",
        "change_zones_description": "Êtes-vous sûr de vouloir modifier la zone des empreintes digitales %{smart_count} ?",
        "change_zones_confirmation": "Je comprends le risque que représente la modification de la zone pour la détermination précise de l'emplacement.",
        "zone_changed": "Zone mise à jour !",
        "error_changing_zone": "Erreur lors de la mise à jour de la zone"
      },
      "fields": {
        "userId": "Empreinte digitale par"
      }
    },
    "kiosks": {
      "text": {
        "manage": "Gérer les kiosques",
        "add_kiosk": "Ajouter un kiosque",
        "add_screen": "Ajouter un écran",
        "general_settings_dialog": {
          "title": "Paramètres du kiosque par défaut",
          "switch_availability": "Disponibilité"
        },
        "kioskConfig": {
          "homepage": {
            "incidentCounter": {
              "last_alarm": "Depuis la dernière alarme"
            }
          }
        },
        "general_settings_updated": "Paramètres du kiosque mis à jour",
        "menu_title": "Kiosques",
        "create_dialog_title": "Créer un kiosque",
        "create_dialog_title_screen": "Créer une URL d'écran",
        "zone_not_found": "Zone non trouvée, non créée...",
        "kiosk_deleted": "Kiosque supprimé",
        "kiosk_delete_title": "Supprimer le kiosque « %{name} »",
        "kiosk_created": "Kiosque créé !",
        "kiosk_created_screen": "Écran créé !",
        "zone_warning": "Ce kiosque sera déplacé au centre de la zone sélectionnée lors de l'enregistrement.",
        "admin_actions": {
          "button": "Actions administratives"
        },
        "kiosk_moved": "Kiosque déplacé !",
        "kiosk_move_title": "Déplacer le kiosque « %{name} »",
        "kiosk_regenerated": "Les identifiants du kiosque ont été régénérés. L'ancienne URL n'est plus utilisable",
        "kiosk_regenerate_button": "Régénérer les identifiants",
        "kiosk_regenerate_title": "Régénérer l'URL pour « %{name} ».",
        "customer_admin_create_dialog_content": "Les kiosques sont un excellent moyen d'afficher et de gérer qui est disponible dans votre organisation.\n\n## Détection de présence avec le kiosque BHV-Knop.nl\nLes kiosques sont principalement destinés aux équipes d'urgence internes à l'entreprise.\n\n[En savoir plus sur la détection de présence](https://bhv-knop.nl/en/hoe-werkt-het/aanwezigheidsdetectie/ (English))\n\n## Matériel\nNous proposons une solution entièrement gérée avec nos écrans tactiles pratiques. Principalement destinée à nos clients BHV-Knop.nl.\n\nContactez votre gestionnaire de compte pour plus d'informations.\n\n![Exemple de kiosque](https://bhv-knop.nl/wp-content/uploads/2024/02/kiosks-663x1024.png)\n\n## Afficher un kiosque sur vos propres écrans existants\nNous offrons la possibilité d'afficher le kiosque sur les écrans existants de votre entreprise. Vous recevrez une URL de navigateur Web à afficher à l'écran.\n\nVous ne possédez pas actuellement cette licence. Contactez votre gestionnaire de compte pour plus d'informations.",
        "general_settings": {
          "overwrite": "Remplacer la configuration par défaut"
        },
        "default_config": "Configure",
        "kiosk_preview": "Aperçu du kiosque",
        "create_mode_dialog_title": "Vous souhaitez créer un nouveau kiosque ou un écran ?",
        "add_kiosk_subtext": "Ajouter un kiosque géré",
        "status": {
          "online": "Kiosque vu dans les 30 dernières minutes.",
          "offline": "Kiosque non vu au cours des 30 dernières minutes."
        },
        "none_yet": "Pas encore de kiosques",
        "edit_single_confirm_content": "Êtes-vous sûr de vouloir modifier un seul kiosque ? Vous pouvez également modifier les paramètres généraux du kiosque pour ce compte.",
        "edit_single_confirm_title": "Etes-vous sûr de vouloir modifier un seul kiosque ?",
        "edit_single_confirm_cancel": "Non, modifier les paramètres généraux des kiosques",
        "edit_single_confirm_confirm": "Oui, continuer à éditer",
        "publish": "Publier sur %{smart_count} kiosque |||| Publier sur %{smart_count} kiosques",
        "defaults": "Paramètres par défaut du kiosque",
        "menu_title-beta": "Kiosques (Bêta)",
        "kiosk_created_but_failed_to_sync_zone_in_client_config": "Borne créée, mais la synchronisation de la zone a échoué."
      }
    },
    "groups": {
      "text": {
        "bhvk-explanation": "Les groupes sont utilisés pour séparer les utilisateurs de votre organisation. Vous pouvez par exemple créer un groupe avec les BHV'ers et un groupe « Head BHV » ou « AIT (Aggression Intervention Team »). BHV-Knop.nl peut travailler avec vous pour établir une distinction par groupe quant à la manière et au moment où l'alarme se déclenche.",
        "members": "1 membre |||| %{smart_count} membres"
      }
    },
    "auditlogs": {
      "text": {
        "subject": "Sujet",
        "user": "Utilisateur",
        "operation": "Action",
        "title": "Journaux d'audit",
        "resource_types": "Types de ressources",
        "expose_users": "Exposer les utilisateurs"
      }
    },
    "customer-alarm-center-relations": {
      "title": "Relations avec les centrales d'alarme",
      "fields": {
        "enabled": "Activé",
        "priority": "Priorité"
      },
      "name": "Relation avec le centre d'alarme"
    },
    "config": {
      "text": {
        "defaults_updated": "Paramètres par défaut du kiosque mis à jour",
        "defaults_update_error": "Erreur lors de la mise à jour des valeurs par défaut. Une ou plusieurs clés ne sont pas mises à jour",
        "no_access": "Pas d'accès"
      }
    },
    "registration-templates": {
      "fields": {
        "profile": {
          "assetGroups": "Groupes d'actifs",
          "legacyConfigGroups": "Groupes de configuration hérités",
          "configGroups": "Groupes de configuration",
          "assetGroupLimit": "Limiter aux groupes"
        },
        "numberUsed": "Numéro utilisé"
      },
      "text": {
        "title": "Modèles d'inscription"
      }
    },
    "legacy-domainlinks": {
      "title": "Restrictions de domaine (héritées)"
    },
    "alarm-call-phone-numbers": {
      "fields": {
        "phoneNumber": "Numéro de téléphone",
        "type": "Taper",
        "numberOfAssetGroupsAndAssets": "Nombre de groupes d'actifs/actifs",
        "timesCalled": "Les temps appelés",
        "lastTimeCalled": "La dernière fois, j'ai appelé à"
      },
      "type": {
        "general": "Général",
        "additional": "Additionnel"
      },
      "lastTimeCalled": {
        "neverCalled": "Jamais"
      },
      "text": {
        "page_info": "Chaque numéro de téléphone de ce tableau renvoie à sa page de configuration. Toute modification de ces configurations peut affecter la réponse aux alarmes et la création d'alarmes.\n\nCette page vous permet de consulter ou de modifier les numéros de téléphone d'un client et, grâce aux boutons d'action correspondants, d'afficher ou de modifier leur configuration.",
        "general_customer_config_button": "Configurations client générales",
        "addGeneral": "Ajouter un numéro général",
        "addAdditional": "Ajouter un numéro supplémentaire",
        "add_general_number_button": "Ajouter",
        "buy_additional_number_button": "Acheter",
        "selectInput": {
          "selectCountry": "Sélectionnez un pays",
          "options": {
            "countryID": "Pays-Bas",
            "countryName": "Pays-Bas"
          }
        },
        "successMessage": {
          "addGeneral": "Le numéro de téléphone général a été ajouté avec succès",
          "addAdditional": "Le numéro de téléphone supplémentaire a été ajouté avec succès"
        },
        "errorMessage": {
          "addGeneral": "Impossible d'ajouter le numéro de téléphone général",
          "addAdditional": "Impossible d'ajouter un numéro de téléphone supplémentaire"
        },
        "generalConfig": {
          "title": "Configurations générales",
          "manageCustomer": "Gérer les clients"
        },
        "unlink_customer_button": "Déconnecter le client"
      },
      "title": "Numéros de téléphone pour les appels d'alarme",
      "create": {
        "title": "Créer un numéro de téléphone"
      }
    },
    "certification-categories": {
      "title": "Catégories de certification",
      "fields": {
        "validity_period": "Période de validité",
        "is_documentary_proof_required": "Exige une preuve documentaire",
        "people_to_notify": "Personnes à informer",
        "custom_reminder_periods": "Périodes de rappel personnalisées",
        "reminder_periods": "Périodes de rappel",
        "certified_user": "Utilisateur certifié",
        "certified_users": "Utilisateurs certifiés"
      },
      "text": {
        "create_title": "Créer une nouvelle catégorie de certification",
        "category_explanation": "Les catégories de certification permettent de définir les certificats auxquels les utilisateurs de votre organisation peuvent prétendre. Par exemple, vous pouvez créer une catégorie de certification pour « Intervenant BHV », puis attribuer ce type de certificat aux utilisateurs du tableau de bord.",
        "certified_users": "utilisateurs certifiés",
        "certified_users_dialog_title": "Utilisateurs certifiés pour",
        "certified_users_dialog_empty": "Il n'y a aucun utilisateur certifié pour cette catégorie.",
        "count": "Compter",
        "expiring": "expiration",
        "title_single": "Catégorie de certification",
        "expiring_certifications_dialog_title": "Certificats expirant pour",
        "days_until_expiry": "jours avant l'expiration",
        "already_expired_for": "Déjà expiré pour",
        "edit_confirmation_dialog_title": "Confirmer la modification",
        "edit_confirmation_dialog_content": "Êtes-vous sûr de vouloir définir les justificatifs comme « non requis » ? Cela supprimera tous les justificatifs existants pour cette catégorie.",
        "expires_today": "Expire aujourd'hui",
        "add_from_presets_title": "Ajouter des catégories de certification à partir des préréglages",
        "add_from_presets_subtitle": "Vous pouvez ajouter des certificats prédéfinis à votre organisation",
        "custom_reminder_create": "+ Créer",
        "custom_reminder_period_title": "Ajouter une période de rappel personnalisée\n",
        "no_results": "Aucun résultat pour votre recherche",
        "name_helper": "Par exemple, \"certificat BHV\"",
        "validity_period_helper": "Combien de temps un certificat de ce type est-il valable ?",
        "people_to_notify_helper": "Qui doit recevoir des notifications concernant l'expiration des certificats ?",
        "reminder_periods_helper": "Combien de temps avant l'expiration les e-mails doivent-ils être envoyés ? Vous pouvez sélectionner plusieurs options",
        "documentary_proof_helper": "Est-il obligatoire de télécharger le scan du certificat ?",
        "filter_by": "Filtrer par",
        "expired": "expiré",
        "valid": "valide",
        "user_count": "Nombre d'utilisateurs",
        "certified": "certifié",
        "expiring_certifications_dialog_empty": "Aucun certificat en expiration pour cette catégorie",
        "expired_certifications_dialog_empty": "Aucun certificat expiré pour cette catégorie",
        "expired_certifications_dialog_title": "Certificats expirés pour",
        "users_dialog_title": "Certificats pour",
        "users_dialog_empty": "Aucun utilisateur trouvé pour cette catégorie",
        "add_category_dialog_title": "Ajouter une catégorie de certification",
        "preset_already_exists": "Une catégorie de certification avec ce nom existe déjà",
        "people_to_notify_title": "Sélectionnez les personnes à informer",
        "certified_users_modal_title": "Gérer les certificats pour la catégorie %{category}",
        "certified_users_select_subtitle": "Gérer les utilisateurs ou les groupes pour la catégorie de certification",
        "certified_users_dates_subtitle": "Renseignez les données pour chaque utilisateur certifié",
        "manage_certificates": "Gérer les certificats",
        "all_users_already_certified": "Tous les utilisateurs disponibles sont déjà certifiés",
        "no_users_added": "Aucun utilisateur certifié ajouté",
        "users_added": "1 utilisateur ajouté |||| %{smart_count} utilisateurs ajoutés",
        "invalid_recipient_selection": "Sélection d'utilisateurs invalide",
        "users_removed": "1 utilisateur supprimé |||| %{smart_count} utilisateurs supprimés"
      },
      "presets": {
        "basic_emergency_response_officer": {
          "name": "Agent d'intervention d'urgence de base (BHV)",
          "description": "Formation de base aux interventions d'urgence, incluant les premiers secours, la lutte contre les incendies et l'évacuation."
        },
        "bhv_team_leader": {
          "name": "Chef d'équipe BHV",
          "description": "Diriger les équipes d'intervention d'urgence lors d'incidents et d'évacuations."
        },
        "head_of_emergency_response": {
          "name": "Responsable des interventions d'urgence",
          "description": "Responsable de l'organisation des interventions d'urgence et de la coordination des procédures d'urgence."
        },
        "basic_vca": {
          "name": "VCA de base",
          "description": "Certificat en matière de sécurité, de santé et d'environnement pour les employés opérationnels."
        },
        "vol_vca": {
          "name": "VOL-VCA",
          "description": "Certificat VCA pour les superviseurs et gestionnaires opérationnels."
        },
        "forklift_certificate": {
          "name": "Certificat de conduite de chariot élévateur",
          "description": "Utilisation sûre des chariots élévateurs et des équipements de transport interne."
        },
        "reach_truck_certificate": {
          "name": "Certificat de chariot élévateur à mât rétractable",
          "description": "Utilisation sécuritaire des chariots élévateurs à mât rétractable dans les entrepôts."
        },
        "aerial_work_platform_certificate": {
          "name": "Certificat de plateforme de travail aérienne",
          "description": "Utilisation sûre des plateformes de travail aériennes et des équipements de travail en hauteur."
        },
        "nen_3140_skilled_person": {
          "name": "NEN 3140 Personne qualifiée",
          "description": "Personne qualifiée pour effectuer des travaux en toute sécurité sur les installations électriques."
        },
        "nen_3140_installation_responsible": {
          "name": "Responsable de l'installation NEN 3140",
          "description": "Personne responsable des installations électriques et du respect des normes de sécurité."
        },
        "respiratory_protection": {
          "name": "Protection respiratoire",
          "description": "Formation à l'utilisation sécuritaire des équipements de protection respiratoire."
        },
        "working_at_height": {
          "name": "Travail en hauteur",
          "description": "Travail en hauteur en toute sécurité, y compris les procédures de protection contre les chutes."
        },
        "basic_first_aid": {
          "name": "Premiers secours de base",
          "description": "Formation de base aux premiers secours et aux soins d'urgence."
        },
        "pediatric_first_aid": {
          "name": "Premiers secours pédiatriques",
          "description": "Premiers secours axés sur les bébés et les enfants."
        },
        "sports_first_aid": {
          "name": "Premiers secours sportifs",
          "description": "Premiers secours axés sur les blessures sportives et les soins d'urgence pendant les activités sportives."
        },
        "first_aid_refresher": {
          "name": "Recyclage en premiers secours",
          "description": "Formation de recyclage annuelle pour le certificat de secourisme."
        },
        "cpr_aed": {
          "name": "RCR / DEA",
          "description": "Formation aux gestes de premiers secours et à l'utilisation d'un défibrillateur automatisé externe (DAE)."
        },
        "text": {
          "search": "Rechercher des préréglages..."
        }
      }
    },
    "security-inventory-categories": {
      "title": "Catégories d'inventaire",
      "text": {
        "sub_title": "L'inventaire relatif à la sécurité comprend les articles essentiels pour garantir la sécurité des personnes au sein de votre organisation.\n\nVous pouvez gérer les catégories de ces articles dans le tableau ci-dessous.",
        "settings_sub_title": "Vous pouvez modifier les paramètres de la catégorie ci-dessous. Assurez-vous de remplir tous les champs obligatoires.",
        "title_single": "Catégorie",
        "select_icon": "Sélectionnez une icône",
        "add_from_presets_title": "Ajouter une catégorie d'inventaire à partir des préréglages",
        "add_from_presets_subtitle": "Vous trouverez ci-dessous les préréglages de catégories d'inventaire. Sélectionnez-en un pour l'ajouter à la liste des catégories d'inventaire disponibles dans votre organisation.",
        "select_category": "Sélectionner une catégorie",
        "settings_button": "Paramètres des catégories",
        "create_title": "Créer une nouvelle catégorie d'articles",
        "category_explanation": "Vous pouvez ajouter ici une catégorie d'article personnalisée si cette catégorie n'est pas disponible dans les préréglages.",
        "no_results": "Aucun résultat pour votre recherche",
        "name_helper": "Par exemple, \"extincteurs\"",
        "people_to_notify_helper": "Qui doit recevoir des notifications concernant l'expiration des articles ?",
        "reminder_periods_helper": "Combien de temps avant l'expiration les e-mails doivent-ils être envoyés ? Vous pouvez sélectionner plusieurs options",
        "inspection_period_helper": "Combien de temps un article de ce type est-il valable avant d'avoir besoin d'une nouvelle inspection ?",
        "add_category_dialog_title": "Ajouter une catégorie d'inventaire",
        "preset_already_exists": "Une catégorie d'inventaire avec ce nom existe déjà",
        "people_to_notify_title": "Sélectionnez les personnes à informer"
      },
      "fields": {
        "inspection_period": "période d'inspection",
        "people_to_notify": "Personnes à informer",
        "icon": "Icône",
        "items_count": "Nombre d'articles"
      },
      "presets": {
        "text": {
          "search": "Rechercher des préréglages..."
        }
      }
    },
    "customer_access_request": {
      "title": "Demande d'accès client",
      "fields": {
        "customer": "Client",
        "duration": "Durée d'accès",
        "reason": "Motif de l'accès",
        "force": "Demande de force",
        "role_preview": "Rôle demandé"
      },
      "options": {
        "duration_1_day": "1 jour",
        "duration_2_days": "2 jours",
        "duration_1_week": "1 semaine",
        "duration_2_weeks": "2 semaines"
      },
      "validation": {
        "customer_required": "Sélectionnez un client",
        "reason_min_length": "La raison doit comporter au moins 10 caractères.",
        "force_short_duration_only": "Les demandes forcées ne sont autorisées que pour 1 ou 2 jours.",
        "no_global_role": "Votre compte ne dispose pas d'un rôle global de vente ou de support pour cette demande."
      },
      "notifications": {
        "submit_success": "Demande d'accès soumise",
        "request_granted": "Votre demande d'accès a été approuvée.",
        "request_denied": "Votre demande d'accès a été refusée.",
        "already_pending": "Vous avez déjà une demande d'accès en attente pour ce client."
      },
      "text": {
        "redirected_from_customer_switch": "Vous n'avez pas encore accès à ce client. Veuillez soumettre une demande pour continuer.",
        "already_pending": "Vous avez déjà une demande d'accès en cours pour ce client. Vous serez averti(e) dès qu'elle aura été examinée.",
        "open_request_locked_with_force": "Une demande d'accès est déjà en attente pour ce client. Les informations ci-dessous ne peuvent pas être modifiées. Forcer l'accès pour obtenir l'autorisation immédiatement. Les administrateurs seront notifiés de cette action.",
        "requesting_for_customer": "Demande d'accès pour %{customer}"
      },
      "actions": {
        "submit": "Soumettre une demande"
      }
    },
    "customer_access_review": {
      "title": "examen des demandes d'accès",
      "fields": {
        "customer": "Client",
        "requested_by": "Demandé par (identifiant utilisateur)",
        "requested_role": "Rôles demandés",
        "valid_until": "Valable jusqu'au",
        "reason": "Raison",
        "force_requested": "Demande forcée",
        "status": "Statut",
        "column_actions": "Actes"
      },
      "status": {
        "open": "Ouvrir",
        "approved": "Approuvé",
        "rejected": "Rejeté"
      },
      "actions": {
        "reload": "Recharger",
        "approve": "Approuver",
        "reject": "Rejeter",
        "reject_reason": "Motif de rejet"
      },
      "validation": {
        "reject_reason_min_length": "Le motif de refus doit comporter au moins 10 caractères."
      },
      "text": {
        "cannot_review_own_request": "Vous ne pouvez pas consulter votre propre demande d'accès",
        "loading": "Chargement…",
        "empty": "Aucune demande d'accès trouvée"
      },
      "forced": {
        "yes": "Oui",
        "no": "Non"
      },
      "notifications": {
        "load_error": "Échec du chargement des demandes d'accès",
        "approve_success": "Demande approuvée",
        "reject_success": "Requête rejetée"
      },
      "switch": {
        "show_all": "Afficher toutes les demandes (y compris celles qui ont été examinées)"
      }
    },
    "security-inventory-items": {
      "text": {
        "search": "Rechercher des articles...",
        "no_results": "Aucun article trouvé",
        "place_item": "Placer l'objet",
        "item_lowercase": "article",
        "delete_dialog_title": "Supprimer les éléments",
        "delete_content": "Êtes-vous sûr de vouloir supprimer ces éléments ?",
        "how_many_items": "Combien d'articles souhaitez-vous ajouter ?",
        "expiry_date_input_helper_text": "La date d'expiration est préremplie à partir de la dernière date de réception, plus la durée de validité de la catégorie d'article. Vous pouvez la modifier manuellement si nécessaire.",
        "all_categories": "Toutes les catégories",
        "categories_chosen": "Catégories sélectionnées",
        "filter_category": "Catégorie",
        "renew_now_modal_title": "Renouveler maintenant",
        "renew_now_modal_helper_text": "La date d'expiration est préremplie à partir de la dernière date d'inspection, plus l'intervalle d'expiration de la catégorie d'article. Vous pouvez la modifier manuellement si nécessaire.",
        "plan_renewal_modal_title": "Planifier le renouvellement",
        "add_planned_renewal_date": "Planifier le renouvellement à une date",
        "remove_planned_renewal_date": "Supprimer la date prévue",
        "manage_inspection": "Gérer l'inspection",
        "choice_dialog_title": "Gérer l'inspection",
        "plan_inspection": "Planifier l'inspection",
        "not_planned_yet": "Pas encore planifié",
        "remove_planned_inspection_date": "Supprimer la date d'inspection prévue",
        "confirm_move_marker_title": "Déplacer l'élément sur la carte ?",
        "confirm_move_marker_content": "L'emplacement a changé. Voulez-vous déplacer cet élément sur la carte vers le nouvel emplacement ?",
        "expiry_date_manual_edit_helper_text": "Vous pouvez modifier ceci manuellement",
        "item": "1 article |||| %{smart_count} articles",
        "planned_inspection_date_helper_text": "Les notifications par e-mail sont reportées jusqu'à la date d'inspection prévue.",
        "show_items_responsible": "Afficher uniquement les éléments dont je suis responsable",
        "show_all_categories": "Afficher toutes les catégories d'inventaire",
        "edit_item_title": "Modifier l’élément %{inventoryCategory}",
        "add_item_dialog": "Où souhaitez-vous placer cet objet de catégorie %{categoryName} ?",
        "renew_now": "Article d'inventaire déjà inspecté",
        "choice_dialog_subtitle": "Comment souhaitez-vous mettre à jour les articles d'inventaire sélectionnés ?",
        "renew_now_subtitle": "Définissez de nouvelles dates d'inspection et d'expiration pour les articles d'inventaire sélectionnés",
        "plan_renewal": "L'article d'inventaire sera inspecté à l'avenir",
        "plan_renewal_subtitle": "Planifiez quand les articles d'inventaire sélectionnés doivent être inspectés",
        "other_inventory_items": "Autre inventaire (%{count})",
        "items_i_am_responsible_for": "Inventaire dont je suis responsable (%{count})"
      },
      "fields": {
        "last_inspection_date": "Date de la dernière inspection",
        "expiry_date": "Date d'expiration",
        "planned_renewal_date": "Date de renouvellement prévue",
        "planned_inspection_date": "Date d'inspection prévue",
        "identifier_placeholder": "id12345",
        "identifier": "Identifiant"
      },
      "validation": {
        "expiry_date_must_be_future": "La date d'expiration doit être future."
      },
      "presets": {
        "fire_extinguishers": {
          "name": "Extincteurs",
          "description": "Extincteurs portatifs ; inspection annuelle par une entreprise certifiée."
        },
        "fire_doors": {
          "name": "Portes coupe-feu",
          "description": "Vérifiez le bon fonctionnement de la fermeture automatique, l'étanchéité et le libre mouvement."
        },
        "fire_dampers_ventilation": {
          "name": "Clapets coupe-feu (ventilation)",
          "description": "Prévention de la propagation du feu par les conduits d'aération ; vérification de la bonne fermeture."
        },
        "fire_alarm_system": {
          "name": "Système d'alarme incendie",
          "description": "Système de détection et d'alarme ; maintenance assurée par un expert."
        },
        "fire_hose_reels": {
          "name": "Dévidoirs de tuyaux d'incendie",
          "description": "Vérifiez la pression de l'eau, l'état du tuyau et son bon fonctionnement."
        },
        "emergency_lighting": {
          "name": "Éclairage de secours",
          "description": "Éclairage de secours ; vérification de la batterie et durée minimale."
        },
        "evacuation_alarm_system": {
          "name": "Système d'alarme incendie et d'évacuation",
          "description": "Alarme d'évacuation ; vérification du fonctionnement et de la clarté."
        },
        "smoke_detectors": {
          "name": "Détecteurs de fumée",
          "description": "Détecteurs de fumée pour la détection précoce des incendies ; vérification du fonctionnement et de la contamination."
        },
        "sprinkler_system": {
          "name": "Système d'extinction automatique à eau",
          "description": "Système automatique d'extinction d'incendie ; inspection du fonctionnement et de l'installation."
        },
        "escape_route_signage": {
          "name": "Signalisation des voies d'évacuation en cas d'incendie",
          "description": "Vérifier la visibilité et la mise à jour."
        },
        "aed_automated_external_defibrillator": {
          "name": "DEA (Défibrillateur externe automatisé)",
          "description": "Vérification de la batterie, des électrodes et de l'indicateur d'état."
        },
        "first_aid_kits": {
          "name": "Trousses de premiers secours",
          "description": "Inspection du contenu, des dates de péremption et réapprovisionnement des fournitures."
        },
        "co2_carbon_monoxide_detectors": {
          "name": "Détecteurs de CO₂ / Monoxyde de carbone",
          "description": "Détection des concentrations dangereuses de CO ; vérification du fonctionnement et de la fiabilité des capteurs."
        },
        "gas_detection_systems": {
          "name": "Systèmes de détection de gaz",
          "description": "Détection des gaz dangereux ; vérification de la précision et des alarmes."
        },
        "evacuation_plans": {
          "name": "Plans d'évacuation",
          "description": "Vérifier que les itinéraires d'évacuation et les points de rassemblement sont à jour."
        },
        "ppe_personal_protective_equipment": {
          "name": "EPI (Équipements de Protection Individuelle)",
          "description": "Inspection visant à détecter l'usure, les dommages et la conformité aux normes."
        },
        "eyewash_station": {
          "name": "Station de lavage oculaire",
          "description": "Rincer la chasse d'eau, vérifier l'absence de fuites"
        },
        "emergency_shower": {
          "name": "Douche de secours",
          "description": "Rincer la chasse d'eau, vérifier l'absence de fuites."
        }
      }
    },
    "expiry_date_display": {
      "text": {
        "click_to_reset_expiry": "Cliquez pour rétablir la date d'expiration à la valeur précalculée"
      }
    },
    "notified-people": {
      "text": {
        "add_email": "+ Ajouter un e-mail",
        "add_email_title": "Ajouter une adresse e-mail",
        "invalid_email": "Veuillez saisir une adresse e-mail valide"
      },
      "fields": {
        "email": "Adresse e-mail"
      }
    }
  },
  "general": {
    "text": {
      "open_in_am": "Gestionnaire d'alarmes",
      "app_mode": {
        "on": "Sur",
        "off": "Désactivé",
        "risk": "Risque"
      },
      "profile": "Profil",
      "true": "vrai",
      "false": "FAUX",
      "move_users_failed": "Tous les utilisateurs n'ont pas été déplacés avec succès",
      "move_users_success": "Tous les utilisateurs ont été déplacés avec succès",
      "move_users_title": "Déplacer les utilisateurs",
      "move_users_explanation": "Déplacer les utilisateurs vers un autre client",
      "move": "Se déplacer",
      "close": "Fermer",
      "deleted": "supprimé",
      "none": "aucun",
      "all": "Tous",
      "yes": "Oui",
      "no": "Non",
      "invalid": "Invalide",
      "saved": "Sauvé",
      "updated": "mis à jour",
      "stability": {
        "unstable": "Instable - N'utilisez pas cette page sans formation adéquate",
        "beta": "Bêta - Vous pouvez utiliser librement cette page mais vous pourriez rencontrer des problèmes",
        "stable": "Stable – Cette page a été testée et devrait fonctionner comme prévu",
        "annotations_title": "Cette page contient les annotations suivantes :"
      },
      "my_user_settings": "Mes paramètres utilisateur",
      "never": "jamais",
      "actions": "Actes",
      "contact_info": "Coordonnées",
      "hover_to_view": "survolez pour voir",
      "export_selection": "Exporter la sélection",
      "export_started": "L'exportation a commencé, veuillez patienter....",
      "exporting": "Exportation...",
      "export_all": "Exporter tout",
      "not_acknowledged": "Non reconnu",
      "show_persons": "Afficher %{length} personnes",
      "copied": "Copié dans le presse-papiers",
      "copy": "Copie",
      "proceed": "Procéder",
      "mobileWarning": "Malheureusement, ce tableau de bord n'a pas été optimisé pour les appareils mobiles. Nous travaillons à l'améliorer. En attendant, nous vous recommandons d'utiliser un PC ou une tablette pour ouvrir cette page.",
      "appUserWarning": "Ce tableau de bord est uniquement destiné aux utilisateurs de gestion de votre organisation.\n\nVous êtes actuellement connecté avec votre compte d'application X-Guard Alarm. Vous ne pouvez pas afficher le tableau de bord de gestion en tant qu'utilisateur de l'application.\nSi vous pouvez consulter notre autre tableau de bord, un bouton pour y accéder apparaîtra dans le coin inférieur.",
      "message": "Message",
      "replace": "Remplacer",
      "append": "Ajouter",
      "skip": "Conserver la valeur actuelle",
      "no_template_selected": "Aucun modèle sélectionné",
      "no_values": "Aucune valeur",
      "no_time_yet": "Pas le temps (encore)",
      "alarm": "Alarme",
      "more_settings": "Plus de paramètres",
      "order": "Commande",
      "orders": "Ordres",
      "help": "Aide",
      "invoices": "Factures",
      "none_yet": "Pas encore de %{name}, veuillez en créer un",
      "settings": "paramètres",
      "install_app": "Installer l'application",
      "when": "Quand?",
      "how_often": "À quelle fréquence?",
      "gateway": "Porte",
      "button": "Bouton",
      "appUserWarning_bhvk": "Ce tableau de bord est uniquement destiné aux personnes ayant obtenu l'accès par un administrateur.\n\nVous êtes actuellement connecté avec un compte sans accès à ce tableau de bord. Vous ne pouvez pas afficher le tableau de bord avec ce compte.\nSi vous pouvez consulter notre autre tableau de bord, un bouton pour y accéder apparaîtra dans le coin inférieur.",
      "number_unknown": "numéro inconnu",
      "change_username_modal_title": "Bienvenue sur le tableau de bord de BHV-Knop.nl",
      "current_username": "Nous avons automatiquement créé un nom d'utilisateur pour vous, vous pouvez le modifier ici",
      "continue": "continuer",
      "current": "Actuel",
      "not_in": "Pas dans",
      "test": "Test",
      "send": "Envoyer",
      "persons": "Personnes",
      "current_user": "Utilisateur actuel",
      "this_dashboard": "Ce tableau de bord",
      "enabled": "Activé",
      "disabled": "Désactivé",
      "or": "ou",
      "cannot_save": "Impossible de sauvegarder",
      "no_changes": "Aucun changement",
      "theme": "Thème",
      "export_select_columns": "Sélectionner les colonnes",
      "toggle_all": "Basculer tout",
      "logo": "URL du logo",
      "filter": "Filtre",
      "location": "Emplacement",
      "search_google_maps": "Recherche via Google Maps",
      "saving": "Économie...",
      "order_extra": "Commander en plus",
      "solve_issues": "Résoudre les problèmes",
      "welcome": "Accueillir",
      "gateways": "Passerelles",
      "order_singular": "Commande",
      "online": "En ligne",
      "last_days": "derniers %{count} jours",
      "incorrect_phonenumber": "Numéro de téléphone incorrect, réessayez",
      "free_trial": "Essai gratuit",
      "licence_active": "Licence active",
      "simulate_customer_admin": "Simuler l'administration client",
      "exit_role_simulation": "Simulation de rôle de sortie",
      "upload_file": "Télécharger le fichier",
      "emergency_button": "Bouton d'urgence",
      "select_all": "Sélectionner tout",
      "deselect_all": "Désélectionner tout",
      "order_now": "Commandez maintenant",
      "emergency_buttons": "Boutons d'urgence",
      "filtered": "Filtré",
      "go_to_management": "Accéder au tableau de bord de gestion",
      "go_to_bhvk": "Accéder à Beheer.BHV-Knop",
      "form": {
        "inherit": "Hériter",
        "override": "Outrepasser"
      },
      "map_floors": "Sol",
      "device": "Appareil",
      "search_location": "Emplacement de la recherche",
      "availability": "Disponibilité",
      "from": "Depuis",
      "until": "Jusqu'à",
      "optional": "facultatif",
      "general": "Général",
      "invalid_time": "Doit être une heure valide",
      "time_end_before_start": "L'heure de fin doit être postérieure à l'heure de début",
      "timestamp": "Horodatage",
      "history": "Histoire",
      "seconds": "secondes",
      "person": "personne |||| personnes",
      "customer_not_found": "Aucun client trouvé avec l'ID donné",
      "present": "Présent",
      "overwrite": "Écraser",
      "add": "Ajouter",
      "remove": "Retirer",
      "buttons_or_persons": "Boutons ou personnes",
      "add_from_presets": "Ajouter à partir des préréglages",
      "edit": "Modifier",
      "loading": "Chargement",
      "loading_secondary": "S'il vous plaît, attendez",
      "items": "Articles",
      "confirm": "Confirmer",
      "days": "jours",
      "time_granularity_types": {
        "day": "1 jour |||| %{smart_count} jours",
        "week": "1 semaine |||| %{smart_count} semaines",
        "month": "1 mois |||| %{smart_count} mois",
        "quarter": "1 trimestre |||| %{smart_count} trimestres",
        "year": "1 an |||| %{smart_count} années"
      },
      "add_email": "+ Ajouter un e-mail",
      "add_email_title": "Ajouter une adresse e-mail",
      "invalid_email": "Veuillez saisir une adresse e-mail valide",
      "add_custom_category": "Ajouter une catégorie personnalisée",
      "add_custom_category_subtitle": "Ajouter une catégorie personnalisée en configurant tous les paramètres manuellement",
      "add_from_presets_subtitle": "Sélectionnez une ou plusieurs catégories préconfigurées",
      "clear": "Effacer",
      "next": "Suivant",
      "email_will_not_be_sent": "Aucun e-mail ne sera envoyé, car aucune personne responsable n'est assignée.",
      "will_receive": "est responsable de %{categoryName}. |||| sont responsables de %{categoryName}.",
      "users": "%{count} utilisateurs",
      "email_will_be_sent": "Le prochain courriel sera envoyé demain. |||| Le prochain courriel sera envoyé dans %{smart_count} jours.",
      "will_be_sent_today": "Le prochain e-mail sera envoyé aujourd’hui.",
      "will_not_be_sent_item_expired": "Aucun courriel ne sera envoyé. Article expiré hier. |||| Aucun courriel ne sera envoyé. Article expiré il y a %{smart_count} jours.",
      "will_not_be_sent_certification_expired": "Aucun courriel ne sera envoyé. Le certificat a expiré hier. |||| Aucun courriel ne sera envoyé. Le certificat a expiré il y a %{smart_count} jours.",
      "responsible_users": "Utilisateur responsable: |||| Utilisateurs responsables:",
      "certified_users": "Utilisateur certifié:"
    },
    "fields": {
      "createdAt": "Créé à",
      "updatedAt": "Mis à jour à",
      "position": {
        "address": {
          "countrycode": "Code du pays",
          "state": "État",
          "city": "Ville",
          "streetName": "Nom de la rue",
          "streetNumber": "Numéro de rue",
          "floor": "Sol",
          "formattedAddress": "Adresse formatée enregistrée",
          "name": "Adresse"
        },
        "latitude": "Latitude",
        "longitude": "Longitude",
        "coordinates": "Coordonnées",
        "name": "Position",
        "properties": {
          "dateTime": "Horodatage de la position"
        }
      },
      "name": "Nom",
      "description": "Description",
      "person_or_object": "Personne ou objet",
      "madeBy": "Réalisé par",
      "number": "Nombre",
      "registration_profile": "Profil d'inscription",
      "email": "Adresse e-mail"
    },
    "errors": {
      "username_too_short": "Le nom d'utilisateur doit comporter au moins trois caractères."
    }
  },
  "pages": {
    "live_map": {
      "text": {
        "no_assets_in_customer": "Aucune personne ni objet trouvé",
        "position_is": "La position est",
        "indoors": "à l'intérieur",
        "outdoors": "en plein air",
        "at": " à",
        "accuracy": "La précision est de %{accuracy} mètres",
        "last_position": "La dernière position était %{time}",
        "person_available": "Cette personne est %{available} disponible",
        "not": "pas",
        "app_mode": "Le mode application est"
      }
    },
    "userReceiverInitialisation": {
      "title": "Comment souhaitez-vous recevoir les alarmes ?"
    }
  },
  "menu": {
    "items": {
      "live": "En direct",
      "map": "Carte",
      "my_organisation": "Mon organisation",
      "alarms": "Alarmes",
      "create_alarm": "Créer une alarme",
      "access": "Accéder",
      "root_admins": "Administrateurs root",
      "problematic_alarms": "Alarmes problématiques",
      "alarm_app": "Application d'alarme X-Guard",
      "groups": "Groupes",
      "qr_codes": "Codes QR",
      "people_assets": "Personnes et actifs",
      "assets": "Actifs",
      "tags": "Mots clés",
      "flic": "Flic",
      "alarm_tasks": "Tâches d'alarme",
      "resources": "Ressources",
      "alarm_handling": "Gestion des alarmes",
      "reports": "Rapports",
      "manage": "Gérer",
      "users": "Administrateurs",
      "management_users": "Utilisateurs",
      "dashboard": "Tableau de bord",
      "maps": "Cartes",
      "response": "Réponse",
      "app-defaults": "Paramètres de configuration par défaut de l'application",
      "certifications": "Certificats",
      "security_inventory": "Inventaire de sécurité",
      "customer_access_request": "Demande d'accès client",
      "customer_access_review": "Examiner les demandes d'accès client"
    },
    "text": {
      "brought_by": "Présenté par"
    }
  },
  "home": {
    "text": {
      "title": "Bienvenue sur le tableau de bord de gestion X-Guard",
      "description": "Vous pouvez utiliser ce tableau de bord pour visualiser votre environnement X-Guard actuel. Malheureusement, il n'est pas encore possible de modifier les ressources que vous pouvez voir. Des possibilités d'édition et de création seront ajoutées ultérieurement.",
      "block_one": "### Bienvenue dans le tableau de bord de gestion X-Guard\n\nVous pouvez utiliser ce tableau de bord pour gérer et afficher votre environnement X-Guard actuel.",
      "block_two": "#### Mise à jour 1.21\nLa page Disponibilité est désormais disponible pour vous permettre de surveiller vos zones. Visualisez instantanément le nombre de personnes disponibles dans vos zones pour répondre aux alarmes.\n\nDe plus, vous pouvez choisir de recevoir des avertissements par e-mail lorsque le seuil défini n'est pas atteint.\n\n#### Mise à jour 1.20\nÀ partir de cette version, il est possible d'ajouter des plans d'étage. Les cartes sont visibles sur toutes les pages comportant une carte dans ce tableau de bord et sur les écrans de kiosque BHV-Knop.nl de votre organisation. Les plans d'étage sont également utilisés par les répartiteurs pour localiser plus précisément un bâtiment.\n\nDe plus, divers rapports sont désormais ajoutés sous la rubrique « Live » avec lesquels vous pouvez immédiatement surveiller l'état actuel de votre organisation.\n\n#### Mise à jour 1.19\nCette version était une mise à jour de stabilité plus importante.\n\n#### Mise à jour 1.18\nIl est désormais possible de gérer les rapports directement depuis ce tableau de bord. Ajustez si les rapports sont envoyés et à qui.\n\n#### Mise à jour 1.17\n\nÀ partir de la version 1.17, vous pouvez désormais accéder à la page de configuration des zones. Cette page vous donne un aperçu de la manière dont certaines zones sont définies dans le système X-Guard.\n\nVous pouvez modifier, ajouter et supprimer des zones. Cependant, l'ajout d'une configuration avancée à une zone est toujours effectué par l'équipe d'assistance X-Guard. Pour votre sécurité, il n'est pas possible de supprimer une zone à laquelle est associée une configuration avancée.\n\nVous ne savez pas par où commencer ? Veuillez contacter votre responsable de compte X-Guard pour obtenir une brève explication.\n\n#### Mise à jour 1.16\n\nIl est désormais possible d'**ajouter, de supprimer et de modifier** des utilisateurs de l'application directement depuis le tableau de bord. Vous pouvez également **gérer les groupes** et **gérer les utilisateurs**.\n\nLes utilisateurs de l'application sont des utilisateurs qui peuvent utiliser l'application X-Guard Alarm. Ils ne peuvent pas utiliser le tableau de bord de gestion et le gestionnaire d'alarmes.\n\nLes utilisateurs ont accès au tableau de bord de gestion et au gestionnaire d'alarmes et peuvent effectuer des tâches administratives.",
      "block_three": "#### Commentaires\n\nVous rencontrez quelque chose dans ce tableau de bord qui ne vous convient pas ? Ou vous avez une nouvelle demande de fonctionnalité ?\n\n**Le coin inférieur droit de toutes les pages** affiche un bouton pratique **Commentaires**. Cliquez sur ce bouton pour envoyer directement vos commentaires à l'équipe de développement X-Guard."
    }
  },
  "ra": {
    "message": {
      "clear_array_input": "Etes-vous sûr de vouloir effacer toute la liste ?"
    },
    "input": {
      "image": {
        "remove_current": "Supprimer le courant"
      }
    },
    "action": {
      "preview": "Aperçu",
      "publish": "Publier",
      "manage_renewal": "Gérer le renouvellement"
    },
    "notification": {
      "name_too_long": "Nom trop long"
    }
  },
  "qr-templates": {
    "text": {
      "page_info": "Vous pouvez utiliser un code QR pour vous inscrire dans votre organisation directement depuis l'application X-Guard Alarm.\n\nPartagez les codes QR avec les personnes qui doivent se connecter dans l'application."
    }
  },
  " resources": {
    "report-triggers": {
      "text": {
        "config_types": {
          "unhealthyBeacons": "Balises malsaines"
        }
      }
    }
  },
  "resource": {
    "customers": {
      "fields": {
        "hasKioskConfig": "A une configuration de kiosque"
      }
    },
    "buttons": {
      "automove_subtitle": "Nous pouvons déplacer automatiquement ce bouton vers la nouvelle adresse. Voulez-vous déplacer ce bouton ?",
      "automove_no": "Non, conserver la position actuelle",
      "automove_yes": "Oui, déplacer automatiquement vers une nouvelle adresse"
    }
  },
  "homepage": {
    "text": {
      "welcome_text2": "sur votre tableau de bord BHV-Knop.nl",
      "welcome_subtext": "Ce tableau de bord vous permet de modifier les paramètres de votre compte BHV-Knop.nl. Téléchargez une carte, placez vos boutons au bon endroit et invitez les membres du BHV.",
      "actual_status": "État actuel de votre système",
      "show_gateways": "Afficher les passerelles",
      "continue_setting_up": "Continuez à configurer votre compte",
      "continue_setting_up_subtext": "Avant de pouvoir déclencher une alarme, vous devez fournir un numéro de téléphone. Celui-ci est nécessaire pour vous appeler en cas d'alarme. Il est possible de recevoir une alarme via notre application."
    }
  },
  "ra-audit-log": {
    "inline_event": {
      "read": "Lire"
    }
  },
  "notifications": {
    "customer_access_request_browser": {
      "title": "Demande d'accès client",
      "body_fallback": "Une nouvelle demande d'accès client est en attente.",
      "customer_id_prefix": "Client ",
      "user_id_prefix": "Utilisateur "
    }
  },
  "clientConfig": {
    "menu": {
      "manager": "Gestionnaire de configuration client",
      "groups": "Groupes de configuration client"
    },
    "buttons": {
      "openManager": "Ouvrir le gestionnaire de configuration client"
    },
    "manager": {
      "title": "Gestionnaire de configuration client",
      "customer": "Client",
      "group": "Groupe",
      "device": "Appareil",
      "assignedGroups": "Groupes de configuration client",
      "selectGroups": "Groupes sélectionnés",
      "changedKeys": "Touches modifiées par rapport aux touches par défaut",
      "baseline": {
        "settings": "Paramètres de base",
        "selectLabel": "Comparer par défaut",
        "mode": {
          "allCustomers": "Tous les clients (mondial)",
          "thisCustomer": "Ce client",
          "thisGroup": "Ce groupe",
          "thisDevice": "Cet appareil"
        },
        "customerUnavailable": "Impossible d'identifier le client pour cet article.",
        "groupUnavailable": "La ligne de base du groupe n'est disponible que lors de la modification d'un groupe.",
        "deviceUnavailable": "La configuration de référence de l'appareil n'est disponible que lors de la modification d'un appareil."
      },
      "resetInlineKey": "Réinitialiser les paramètres",
      "restoreInlineKey": "Restaurer les paramètres",
      "unsavedChanges": {
        "title": "Modifications non enregistrées",
        "message": "Vous avez des modifications de groupe ou de touches non enregistrées. Veuillez les enregistrer avant de quitter cette page.",
        "save": "Sauvegarder",
        "stay": "Restez sur la page"
      }
    },
    "groups": {
      "form": {
        "groups": "Groupes de configuration client",
        "keys": "Clés de configuration du client",
        "key": "Clé",
        "editable": "Modifiable",
        "editableBy": "Modifiable par",
        "customerSpecific": "Groupe spécifique au client"
      },
      "preview": {
        "title": "Aperçu de la configuration client",
        "noChanges": "Aucune modification par rapport à la configuration par défaut.",
        "inlineKey": "Clé en ligne (aucune source de groupe)",
        "description": "Aperçu de l'impact de l'ajout ou de la suppression de groupes et de clés sur la configuration client résultante."
      },
      "list": {
        "showGlobalGroups": "Afficher les groupes ClientConfig globaux"
      }
    },
    "preview": {
      "chip": {
        "new": "Nouveau",
        "changed": "Modifié",
        "removedByGroup": "Supprimé par changement de groupe",
        "editedByOtherGroup": "Modifié par un autre groupe",
        "removedInlineKey": "Paramètre supprimé"
      }
    },
    "osFilter": {
      "ios": "iOS",
      "overridesTitle": "Surcharge spécifique à l'OS",
      "addOverride": "Ajouter une surcharge OS",
      "android": "Android",
      "allDevices": "Tous les appareils",
      "osType": "Système d'exploitation",
      "osVersionRange": "Plage de versions OS",
      "targetFilterHelp": "S'applique uniquement à ce bloc de configuration.",
      "duplicateOsType": "Une surcharge pour cet OS et cette plage de versions existe déjà.",
      "osVersionRangeHelp": "Semver facultatif, p. ex. >=12.0.0",
      "enabled": "Limiter à un OS spécifique"
    }
  }
} as const

export default language